<template lang="pug">
#mainBody(class="default")
  #one
    section#home.s-home.page-hero.target-section(:style="`top:0; height: 100%;width: 100%;`")
        parallax(:name="'home2'")
          //#homeimage.isdesktop(:astyle="`background-image:url(${image0});filter: brightness(0.5);width:100%;height:100%;position: absolute;`")
            video(autoplay="" loop="" muted="" playsinline="" poster="base.jpg")
              source(src="peoplesmallnew.mp4" type="video/mp4")
          #homeimage.isdesktop(style="filter: brightness(0.5);width:100%;height:100%;position: absolute;`")
            video(:autoplay="true"  :muted="true"  :loop="loop" ref="frontVideo" id="frontPageVideo" :playsinline="true" @ended="onEnd()" poster="base.jpg")
              source(data-src="peoplesmallnew.mp4" :src="videosrc"  type="video/mp4") 
          .home-content.global(ref="home" :style="`height: 100vh !important;width: 100vw !important;`")
            .row.home-content__main
              #subheaders
                h1 Welcome to Genoplot
              //  h3#subh Your Ancestry, Visualized...
              .row.home-content__teasers
                #subheaders
                  h3 Free Ancestry Analysis
                  h3#subh Upload your 23andMe, AncestryDNA, FTDNA and MyHeritage files
                  h3 Free Global 25 Coordinates
                  h3#subh As easy as running one of our admixture calculators
                  h3 Calculators Galore
                  h3#subh 100s of free G25 and Admixture Calculators...
              .home-content__buttons
                span.smoothscroll.btn.btn--stroke(href=null v-on:click="username ? signOut() : showSignUp('news', 'Admixture')")
                  | {{ username ? 'Sign Out' : 'Sign Up' }}
                span.smoothscroll.btn.btn--stroke(href=null v-on:click="showAbout()")
                  | About Us
              .home-content__scroll
                a.scroll-link.smoothscroll(href="#GenomicAnalysis" v-on:click="smoothScroll('GenomicAnalysis', 'Admixture')")
                  span Scroll Down
            span.item-loop(v-on:click="looped()" :class="loop ? 'looped' : ''" style="border-radius: 50%;position: absolute; bottom: 15px; left: 15px; color: white;-index: 9;cursor: pointer; width: 15px; height: 15px;")
          //.home-content(ref="home" :style="`height: 100vh !important;width: 100vw !important;`")
            .row.home-content__main
              #subheaders
                h3 Welcome to Genoplot
                h3#subh Your Ancestry, Visualized...
    #genotext()
      section.section#Reviews.s-home.page-hero.target-section()
        .about-description.text-center
          .features-3
            .container
              .row
                .col-md-8.mr-auto.ml-auto
                  div.quote-wrapper
                    blockquote.text(cite="https://tim-piatenko.medium.com/dna-analysis-with-genoplot-2e1b1c60f425")
                      p I’ve found Genoplot to be the most advanced application that is reasonably easy to learn and use
                      a(href="https://tim-piatenko.medium.com/dna-analysis-with-genoplot-2e1b1c60f425" target="_blank" rel="noopener noreferrer")
                       footer - Tim Piatenko 
                          span(style="color: white") PhD
      section.section#GenomicAnalysis.s-home.page-hero.target-section(style="margin-top:0;padding-top:0;")
        .about-description.text-center
          .features-3
            .container
              .col-md-8.ml-auto.mr-auto.genomics
                h1.title(style="font-weight:400;color:rgb(255, 255, 255);padding-top:0;margin-top:1.4em;") Genomic Analysis
                .separator-line.separator-primary
              .row
                .col-md-8.mr-auto.ml-auto
                  h4.description(style="padding-bottom: 30px")
                    | Accurate inference of genetic ancestry is important to many consumers of commercial testing services such as 23andMe, AncestryDNA, MyHeritage, LivingDNA and FamilyTreeDNA.
                    br
                    br
                    | Our services allow for raw DNA data from any of these services to be used for further deep-dive analysis of ancestry and admixture.
                    br
                    br
                    b
                      | Best of all, our core services are all available for free to our users!
                    br
                    | We do provide subscription plans for more advanced features that also have higher monthly limits on usage of our services.
              .separator-line.separator-primary
              //.row
                .col-md-8.ml-auto.mr-auto.text-center
                  h2.title Tools
              .row
                .col-md-4
                  .info.info-hover
                    .icon.icon-calc
                      i.now-ui-icons.objects_globe
                    h4.info-title Admixture Calculators
                    p.description
                      | Hundreds of ancestry calculators that allow for much more nuanced views into recent, as well as ancient, ancestral sources. 
                .col-md-4
                  .info.info-hover
                    .icon.icon-monte
                      i.iconCalculator
                    h4.info-title Monte Carlo Simulations
                    p.description
                      | Monte Carlo simulator (nMonte runner) for granular selection of ancestral sources in a mix-and-match manner to create custom ancestry models.
                .col-md-4
                  .info.info-hover
                    .icon.icon-pca
                      i.now-ui-icons.tech_watch-time
                    h4.info-title PCA Plots
                    p.description
                      | PCA (Principal Component Analysis) for visualizing one's  autosomal genetics in relationship to other regional and global populations on 2D and 3D plots.
        .separator-line.separator-primary
        section.section#blog()
          #about.projects-5.features-3
            .container
              .row.mission
                .col-md-8.ml-auto.mr-auto.text-center
                  h2.title Our Mission
                  h4.description
                    | We are a consumer genomics platform whose primary purpose is to ensure that leading-edge ancestry and genetics technology is freely available to the personal genomics community.
                    br
                    br
                    | We’re committed to creating a platform that provides our users with an informative, interactive and fulfilling experience while maintaining the highest standards of personal data privacy.
                  .section-space
                  .signUp.callout(v-if="!username")
                    span.nav-link.btn.btn-primary.login(v-on:click="showSignUp()")
                      p(style="font-size: 1.3em; font-weight: 700;") Sign Up
                    .section-space
              .row
                .col-md-5.ml-auto
                  card.card-background-product(type='background', raised='' :style="`background-image: url(${image1});border-radius: 5px;`")
                    h2.card-title Admixture Calculators
                .col-md-5.mr-auto
                      br
                      br
                      info-section(type='danger', icon='now-ui-icons design-2_ruler-pencil', title=' ', description='The largest selection of admixture calculators available on the web. Including many from well established Genomics projects such as Eurogenes, MDLP and HarappaWorld.')
              .section-space
              .row
                .col-md-5.ml-auto.mt-5
                      info-section(type='danger', icon='now-ui-icons arrows-1_refresh-69', title=' ', description='Mix-and-Match ancestry modeling using coordinates from Eurogenes Global 25 (G25) or results from HarappaWorld, Eurogenes K13, Dodecad K12 and many other admixture calculators. Create and share custom calculators from your ancestry models.')
                .col-md-5.mr-auto
                  card.card-background-product(type='background', raised='' :style="`background-image: url(${image2});border-radius: 5px;`")
                    h2.card-title Monte Carlo Simulations
                    p.card-description.text-white
              .section-space
              .row
                .col-md-5.ml-auto
                  card.card-background-product(type='background', raised='' :style="`background-image: url(${image3});border-radius: 5px;`")
                    h2.card-title PCA Plots 
                .col-md-5.mr-auto
                      br
                      br
                      info-section(type='danger', icon='now-ui-icons design-2_ruler-pencil', title=' ', description='Quickly plot your ancestry models as custom PCA charts. Pre-configured PCA plots for many regional and global populations including West and East Euoropeans, East, West and South Asians as well as North, West and East African groups.')
          .section-space
          .signUp.callout(v-if="!username")
            .section-space
            span.nav-link.btn.btn-primary.login(v-on:click="showSignUp()")
              p(style="font-size: 1.3em; font-weight: 700;") Create your free account
            .section-space
          .about-office.features-3 
            .container
              .row.text-center
                .col-md-8.ml-auto.mr-auto
                  h2.title Extensive sharing features
                  h4.description
                    | Built in article creation and editing capabilities
                    | including a commenting platform with moderation rights for article owners
              .section-space
              .row
                .col-md-12
                  img.rounded.img-raised(alt='Raised Image' loading="lazy" :src="image4" style="max-width: 100%;width: 100%;height: auto;")
              //.row.text-center
                .col-md-8.ml-auto.mr-auto
                  h2.title The best is yet to come
                  h4.description
                    | Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    | Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    | Lorem ipsum dolor sit amet, consectetur adipiscing elit
              //.row
                .col-md-4
                  nuxt-img.rounded.img-raised(alt='Raised Image', src='temp/img/bg27.jpg')
                .col-md-4
                  nuxt-img.rounded.img-raised(alt='Raised Image', src='temp/img/bg24.jpg')
                .col-md-4
                  nuxt-img.rounded.img-raised(alt='Raised Image', src='temp/img/bg28.jpg')
                .col-md-6
                  nuxt-img.rounded.img-raised(alt='Raised Image', src='temp/img/project6.jpg')
                .col-md-6
                  nuxt-img.rounded.img-raised(alt='Raised Image', src='temp/img/project14.jpg')
        section.section#contact.s-home.page-hero.target-section(style="margin-top:-130px")
          .about-contact.features-3 
            .container
              .row
                .col-md-8.mr-auto.ml-auto
                  h4.text-center.description(style="font-family: Belleza;margin-top: 165px;") 
                    | If you have any questions or need additional information, do let us know.
                  form.contact-form
                    .row
                      .col-md-4.ml-auto.mr-auto.text-center
                        span.nav-link.btn.btn-primary.btn-round.mt-4.btn-md(style="margin-top: 32px;color: white;text-transform: uppercase;font-size: 1.2em; font-weight: 700;" v-on:click.stop.prevent="showIntercom()")
                          | Contact Us
</template>
<script lang="js">
  //import { Card, InfoSection } from '@/components';
  import InfoSection from '../components/InfoSection';
  import Card from '../components/Cards/Card';
  let resizeTimeout;

  function resizeThrottler(actualResizeHandler) {
      if (!resizeTimeout) {
          resizeTimeout = setTimeout(() => {
              resizeTimeout = null;
              actualResizeHandler();
          }, 66);
      }
  }
  import {
      mapState
  } from 'vuex';
  import smoothscroll from 'smoothscroll-polyfill';
  smoothscroll.polyfill();
  export default {
      name: 'home',
      bodyClass: 'presentation-page,frontpage',
      computed: {
          ...mapState({
              username: 'user',
              isAdmin: 'isAdmin',
              isMobile: 'isMobile'
          }),
          active: {
              get() {
                  return this.$store.getters.get('activePage');
              },
              set(val) {
                  this.$store.commit('change', {
                      activePage: val
                  })
              }
          },
          hdrClass: {
              get() {
                  return this.$store.getters.get('hdrClass');
              },
              set(val) {
                  this.$store.commit('change', {
                      hdrClass: val
                  })
              }
          },
          hero() {
              let hero = this.$store.getters.get('hero')
              return hero
          },
          imagesReady: {
              get: function() {
                  return this.$store.getters.get('imagesReady')
              },
              set: function(value) {
                  this.$store.commit('change', {
                      imagesReady: value
                  })
              }
          },
          image1: function() {
              return 'temp/img/admixture.png';
          },
          image2: function() {
              return 'temp/img/nmonte.png';
          },
          image3: function() {
              return 'temp/img/pca.png';
          },
          image4: function() {
              return 'temp/img/sharing2.jpg';
          },
          menumeta() {
              let menu = this.$route && this.$route.meta && this.$route.meta.menu ? this.$route.meta.menu : 'home'
              return menu
          },
          image0() {
              return '/img/genome.jpg'
          },
          eventbus: {
              get: function() {
                  return this.$eventBus ? true : false
              }
          },
          contacted: {
              get: function() {
                  return this.$store.getters.get('contacted')
              }
          },
          _srcset() {
              return this.$img.getSizes(this.src, {
                  sizes: 'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw',
                  modifiers: {
                      format: 'webp',
                      quality: 80,
                  },
              });
          },
          startlogin: {
              get: function() {
                  return this.$store.getters.get('login')
              },
              set: function(value) {
                  this.$store.commit('change', {
                      login: value
                  })
              }
          },
      },
      data() {
          return {
              videosrc: null,
              loop: null,
              videoruns: 0,
              meta: {
                  menu: "home",
                  hero: "home",
                  name: 'Home',
                  transparent: true
              },
              menu: [{
                      "item": "Home",
                      "link": "home"
                  },
                  {
                      "link": "Admixture",
                      "nuxt": "admixCalc",
                      "prefetch": false,
                      "offset": -50
                  },
                  {
                      "item": "nMonte",
                      "link": "contact"
                  },
                  {
                      "item": "PCA",
                      "link": "blog"
                  },
                  {
                      "item": "Discussions",
                      "link": "news",
                      "offset": -50
                  },
                  {
                      "item": "Sign In",
                      "method": this.startLogin,
                      "class": "login",
                  }
              ],
              readyForLogin: false,
              initLogin: false,
              prefetched: false,
              bodyClass: process.client && ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone',
                      'iPod'
                  ].includes(navigator.platform) || process.client && (navigator.userAgent.includes("Mac") &&
                      "ontouchend" in document) || process.client && window.navigator && window.navigator
                  .userAgentData && window.navigator.userAgentData.mobile ? 'isMobile' : 'isDesktop',
              innerWidth: undefined,
              innerHeight: undefined,
              image10: this.bodyClass == 'isDesktop' ? '/img/genome.webp' : '',
              stickyClass: '',
              triggerClass: '',
              menu: [{
                      "item": "Home",
                      "link": "home"
                  },
                  {
                      "link": "Admixture",
                      "nuxt": "admixCalc",
                      "prefetch": false,
                      "offset": -50
                  },
                  {
                      "item": "nMonte",
                      "link": "contact"
                  },
                  {
                      "item": "PCA",
                      "link": "blog"
                  },
                  {
                      "item": "Discussions",
                      "link": "contact",
                      "offset": -50
                  },
                  {
                      "item": "Sign In",
                      "method": this.startLogin,
                      "class": "login",
                  }
              ],
              ready: false,
              readylogin: false,
              smallscreen: process.client && window.innerWidth < 1024 ? true : false,
              index: this.$route.params.index ? this.$route.params.index : 0,
              form: {
                  firstName: '',
                  email: '',
                  speciality: ''
              },
              options: {
                  mousewheel: false,
                  loop: false,
                  effect: 'fade',
                  //initialSlide: this.$route.params.index ? this.$route.params.index : this.$route.meta.index ? this.$route.meta.index : 0,
                  cssMode: false,
                  speed: 300,
                  freeMode: true,
                  fadeEffect: {
                      crossFade: true
                  },
                  //onInit: function (swiper) {console.log('done'); swiper.slideTo(1) }
                  //autoplay: { delay: 5000, disableOnInteraction: false }
              }
          }
      },
      onUpdated() {},
      components: {
          Card,
          InfoSection,
      },
      created() {},
      beforeMount() {},
      mounted() {
          let w = this;
          console.log(`Mount started ${Date.now() - routeStart} ms`)
          this.$store.commit('change', {
              hero: 'home'
          })
          if (this.$gbVar) {
              this.$gbVar = this.meta
          }
          if (this.$eventBus) {
              this.$eventBus.$on('authState', data => {
                  if (data == 'readyForLogin') {
                      this.readyForLogin = true;
                  }
              });
          }
          this.startlogin = false;
          if (process.client) {
              let win = window,
                  doc = document,
                  docElem = doc.documentElement,
                  body = doc.getElementsByTagName('body')[0];
              this.innerWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
              this.innerHeight = win.innerHeight || docElem.clientHeight || body.clientHeight;

              let bodyClass = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']
                  .includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
                  window.navigator && window.navigator.userAgentData && window.navigator.userAgentData.mobile ?
                  'isMobile' : 'isDesktop'
          }
          w.imagesReady = false;
          w.active = 'Home'
          this.loop = false;
          w.hdrClass = ''
          w.$nextTick(() => {
              this.$store.commit('change', {
                  spinner: false
              })
              console.log('this.spinner', this.$store.getters.get('spinner'))
              let video = w.$refs.frontVideo
              if (video) {
                  video.addEventListener('loadeddata', function() {
                      video.play()
                  }, false)
                  w.videosrc = "/peoplesmallnew.mp4"
              }
          })
          console.log('mounted front page!');
          /*
		window.path_to_nodebb = 'https://devdiscuss.genoplot.com';
		let css = [
			"https://devdiscuss.genoplot.com/plugins/nodebb-plugin-recent-cards/render/style.css",
			"https://devdiscuss.genoplot.com/plugins/nodebb-plugin-recent-cards/static/bxslider/jquery.bxslider.css"
			]
    let scripts = [
      "https://devdiscuss.genoplot.com/plugins/nodebb-plugin-recent-cards/static/bxslider/jquery.bxslider.min.js",
      "https://devdiscuss.genoplot.com/plugins/nodebb-plugin-recent-cards/static/lib/external.js"
    ];
    css.forEach(style => {
      let tag = document.createElement("link");
      tag.setAttribute("rel", 'stylesheet');
      tag.setAttribute("type", 'text/css');
      tag.setAttribute("href", style);
      tag.setAttribute("loaded", 'ysl');
      document.head.appendChild(tag);
    });
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      tag.setAttribute("loaded", 'ysl');
      document.head.appendChild(tag);
    });
    */
      },
      methods: {
          looped() {
              let w = this;
              w.loop = !w.loop;
              let video = w.$refs.frontVideo
              if (video) {
                  if (w.loop) {
                      video.play()
                  } else {
                      video.pause()
                  }
              } else {}
          },
          onEnd() {
              let w = this;
              let video = w.$refs.frontVideo
              if (w.videoruns >= 100) {
                  w.videoruns = 0;
                  video.pause()
              } else {
                  w.videoruns++
                  video.play()
              }
          },
          goTo(route) {
            this.$router.push({
                name: route || 'landing',
                params: {
                    index: 0
                }
            })
            /*
              this.$eventBus.$emit('appEvents', {
                  exec: 'goTo',
                  params: ['/About', 'About'],
                  component: 'nav'
              })
              */
          },
          showSignUp: async function() {
              /*
              try {
                  this.iterated = this.iterated || 0
                  let hero = this.iterated
                  this.$store.commit('change', { hero: this.iterated })
                  let workers = ['main', 'g25']
                  let start = Date.now()
                  let results1, results2, time1, time2;
                  let resultsArray = workers.map(async worker => {
                  let results
                      if (worker == 'main') {
                          results1 = await this.$worker.postMessage({
                              action: 'getVal',
                              data: 'hero'
                          })
                          results = results1
                      time1 =  Date.now() - start
                      } else {
                          results2 = await this.$worker.postMessage({
                              action: 'sniff'
                          })
                          results = results2
                      time2 =  Date.now() - start
                      }
                      console.log('results', results, Date.now() - start)
                      return results
                  })
                  await Promise.all(resultsArray)
                  this.iterated++
                  console.log('results', resultsArray);
              this.$modal.show('dialog', {
                  class: 'alert',
                  title: 'Sniff Results',
                  text: `Result1 (hero): <b>${results1 && results1.result != undefined ? results1.result : ''}</b>, time: ${time1}<br/>Result2 (indexedDB): <b>${results2 && results2.result && results2.result == 1 ? 'Yes' : 'No'}</b>, time: ${time2}` 
              })
              } catch (err) {
                  console.log(err)
              }
              */
              this.$eventBus.$emit('authState', 'signUp')
          },
          showAbout() {
          this.goTo('about')
          },
          signOut() {
              this.$eventBus.$emit('appEvents', {
                  exec: 'signOut',
                  component: 'nav'
              })
          },
          smoothScroll(link, item) {
              let myEl = document.getElementById(link)
              let body = document.getElementById('app')
              let menuitem = this.menu.find(x => x.link == item)
              let offset = menuitem && menuitem.offset ? menuitem.offset : 0;
              this.$smoothScroll({
                  scrollTo: myEl,
                  container: body,
                  offset: offset,
                  duration: 500
              })
          },
          showIntercom: function() {
              let w = this;
              if (w.$intercom) {
                  w.$intercom.show()
              } else {
                  w.$store.commit('change', {
                      contacted: true
                  })
              }
          },
          scroller() {
              let container = document.getElementById('page')
              let loc = container.scrollTop || 0
              let hero = document.getElementById('home')
              let triggerHeight = hero.offsetHeight - 75;
              console.log(loc, triggerHeight, loc > triggerHeight * 1.5);
              if (loc > triggerHeight * 1.5) {
                  console.log('updated');
                  this.image1 = 'temp/img/admixture.png'
                  this.image2 = 'temp/img/nmonte.png'
                  this.image3 = 'temp/img/pca.png'
                  let bodyClass = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']
                      .includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in
                      document) || window.navigator && window.navigator.userAgentData && window.navigator.userAgentData
                      .mobile ? 'isMobile' : 'isDesktop'
                  if (bodyClass == 'isDesktop') {
                      this.image4 = 'temp/img/sharing2.jpg'
                  } else {
                      this.image4 = 'temp/img/sharing2.jpg'
                  }
              }
          },
      },
      beforeDestroy() {},
  }
</script>
<style lang="css" scoped>
  html {
    overflow: hidden;
    font-display: swap;
    font-family: sans-serif;
    line-height: 1.15;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-size: 10px;
  }

  body {
    margin: 0;
  }

  body.frontpage .card-background .card-body {
    padding: 0;
  }

  .ss-loaded body {}

  article,
  aside,
  footer,
  header,
  nav,
  section {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  figcaption,
  figure,
  main {
    display: block;
  }

  figure {
    margin: 1em 40px;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    font-display: swap;
    font-family: monospace, monospace;
    font-size: 1em;
  }

  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  a:active,
  a:hover {
    outline-width: 0;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: inherit;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-display: swap;
    font-family: monospace, monospace;
    font-size: 1em;
  }

  dfn {
    font-style: italic;
  }

  mark {
    background-color: #ff0;
    color: #000;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  audio,
  video {
    display: inline-block;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  img {
    border-style: none;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-display: swap;
    font-family: sans-serif;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
  html [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  progress {
    display: inline-block;
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  [type="search"]::-webkit-search-cancel-button,
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }

  details,
  menu {
    display: block;
  }

  summary {
    display: list-item;
  }

  canvas {
    display: inline-block;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none;
  }

  /* ===================================================================
 * # basic/base setup styles - (_basic.scss)
 *
 * ------------------------------------------------------------------- */

  html {
    font-size: 62.5%;
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-weight: normal;
    line-height: 1;
    word-wrap: break-word;
    text-rendering: optimizeLegibility;
    -webkit-overflow-scrolling: touch;
    -webkit-text-size-adjust: none;
  }

  body,
  input,
  button {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  /* ------------------------------------------------------------------- 
 * ## Media - (_basic.scss)
 * ------------------------------------------------------------------- */

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  /* ------------------------------------------------------------------- 
 * ## Typography resets - (_basic.scss)
 * ------------------------------------------------------------------- */

  div,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pre,
  form,
  p,
  blockquote,
  th,
  td {
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    -webkit-font-smoothing: auto;
    -webkit-font-smoothing: antialiased;
    -webkit-font-variant-ligatures: common-ligatures;
    -moz-font-variant-ligatures: common-ligatures;
    font-variant-ligatures: common-ligatures;
    text-rendering: optimizeLegibility;
  }

  em,
  i {
    font-style: italic;
    line-height: inherit;
  }

  strong,
  b {
    font-weight: bold;
    line-height: inherit;
  }

  small {
    font-size: 60%;
    line-height: inherit;
  }

  ol,
  ul {
    list-style: none;
  }

  li {
    display: block;
  }

  /* ------------------------------------------------------------------- 
 * ## links - (_basic.scss)
 * ------------------------------------------------------------------- */

  a {
    text-decoration: none;
    line-height: inherit;
  }

  a img {
    border: none;
  }

  /* ------------------------------------------------------------------- 
 * ## inputs - (_basic.scss)
 * ------------------------------------------------------------------- */

  fieldset {
    margin: 0;
    padding: 0;
  }

  input[type="email"],
  input[type="number"],
  input[type="search"],
  input[type="text"],
  input[type="tel"],
  input[type="url"],
  input[type="password"],
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
  }

  /* ===================================================================
 * # grid - (_grid.scss)
 *
 * ------------------------------------------------------------------- */

  .row {
    width: 94%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .row:after {
    content: "";
    display: table;
    clear: both;
  }

  .row .row {
    width: auto;
    max-width: none;
    margin-left: -20px;
    margin-right: -20px;
  }

  /* column blocks
 * -------------------------------------- */

  [class*="col-"] {
    float: left;
  }

  [class*="col-"]+[class*="col-"].end {
    float: right;
  }

  [class*="col-"] {
    padding: 0 20px;
  }

  /* column width classes 
 * -------------------------------------- */

  .col-one {
    width: 8.33333%;
  }

  .col-two,
  .col-1-6 {
    width: 16.66667%;
  }

  .col-three,
  .col-1-4 {
    width: 25%;
  }

  .col-four,
  .col-1-3 {
    width: 33.33333%;
  }

  .col-five {
    width: 41.66667%;
  }

  .col-six,
  .col-1-2 {
    width: 50%;
  }

  .col-seven {
    width: 58.33333%;
  }

  .col-eight,
  .col-2-3 {
    width: 66.66667%;
  }

  .col-nine,
  .col-3-4 {
    width: 75%;
  }

  .col-ten,
  .col-5-6 {
    width: 83.33333%;
  }

  .col-eleven {
    width: 91.66667%;
  }

  .col-twelve,
  .col-full {
    width: 100%;
  }

  /* ------------------------------------------------------------------- 
 * ## medium size devices - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .row .row {
      margin-left: -15px;
      margin-right: -15px;
    }

    [class*="col-"] {
      padding: 0 15px;
    }

    .md-two,
    .md-1-6 {
      width: 16.66667%;
    }

    .md-one {
      width: 8.33333%;
    }

    .md-three,
    .md-1-4 {
      width: 25%;
    }

    .md-four,
    .md-1-3 {
      width: 33.33333%;
    }

    .md-five {
      width: 41.66667%;
    }

    .md-six,
    .md-1-2 {
      width: 50%;
    }

    .md-seven {
      width: 58.33333%;
    }

    .md-eight,
    .md-2-3 {
      width: 66.66667%;
    }

    .md-nine,
    .md-3-4 {
      width: 75%;
    }

    .md-ten,
    .md-5-6 {
      width: 83.33333%;
    }

    .md-eleven {
      width: 91.66667%;
    }

    .md-twelve,
    .md-full {
      width: 100%;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## tablets - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 800px) {
    .row {
      width: 90%;
    }

    .tab-1-4 {
      width: 25%;
    }

    .tab-1-3 {
      width: 33.33333%;
    }

    .tab-1-2 {
      width: 50%;
    }

    .tab-2-3 {
      width: 66.66667%;
    }

    .tab-3-4 {
      width: 75%;
    }

    .tab-full {
      width: 100%;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## mobile devices - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 600px) {
    .row {
      width: auto;
      padding-left: 25px;
      padding-right: 25px;
    }

    .row .row {
      margin-left: -10px;
      margin-right: -10px;
    }

    [class*="col-"] {
      padding: 0 10px;
    }

    .mob-1-4 {
      width: 25%;
    }

    .mob-1-3 {
      width: 33.33333%;
    }

    .mob-1-2 {
      width: 50%;
    }

    .mob-2-3 {
      width: 66.66667%;
    }

    .mob-3-4 {
      width: 75%;
    }

    .mob-full {
      width: 100%;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## small mobile devices - (_grid.scss) 
 * ------------------------------------------------------------------- */

  /* stack columns on small mobile devices
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 400px) {
    .row .row {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
    }

    [class*="col-"] {
      width: 100% !important;
      float: none !important;
      clear: both !important;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
    }

    [class*="col-"]+[class*="col-"].end {
      float: none;
    }
  }

  /* ===================================================================
 * # block grids - (_grid.scss)
 * ------------------------------------------------------------------- */

  /*   Equally-sized columns define at row level
 * ------------------------------------------------------------------- */

  [class*="block-"]:after {
    content: "";
    display: table;
    clear: both;
  }

  .block-1-6 .col-block {
    width: 16.66667%;
  }

  .block-1-5 .col-block {
    width: 20%;
  }

  .block-1-4 .col-block {
    width: 25%;
  }

  .block-1-3 .col-block {
    width: 33.33333%;
  }

  .block-1-2 .col-block {
    width: 50%;
  }

  /**
 * Clearing for block grid columns. Allow columns with 
 * different heights to align properly.
 */

  .block-1-6 .col-block:nth-child(6n+1),
  .block-1-5 .col-block:nth-child(5n+1),
  .block-1-4 .col-block:nth-child(4n+1),
  .block-1-3 .col-block:nth-child(3n+1),
  .block-1-2 .col-block:nth-child(2n+1) {
    clear: both;
  }

  /* ------------------------------------------------------------------- 
 * ## medium size devices - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .block-m-1-6 .col-block {
      width: 16.66667%;
    }

    .block-m-1-5 .col-block {
      width: 20%;
    }

    .block-m-1-4 .col-block {
      width: 25%;
    }

    .block-m-1-3 .col-block {
      width: 33.33333%;
    }

    .block-m-1-2 .col-block {
      width: 50%;
    }

    .block-m-full .col-block {
      width: 100%;
      clear: both;
    }

    [class*="block-m-"] .bgrid:nth-child(n) {
      clear: none;
    }

    .block-m-1-6 .col-block:nth-child(6n+1),
    .block-m-1-5 .col-block:nth-child(5n+1),
    .block-m-1-4 .col-block:nth-child(4n+1),
    .block-m-1-3 .col-block:nth-child(3n+1),
    .block-m-1-2 .col-block:nth-child(2n+1) {
      clear: both;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## tablets - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 800px) {
    .block-tab-1-6 .col-block {
      width: 16.66667%;
    }

    .block-tab-1-5 .col-block {
      width: 20%;
    }

    .block-tab-1-4 .col-block {
      width: 25%;
    }

    .block-tab-1-3 .col-block {
      width: 33.33333%;
    }

    .block-tab-1-2 .col-block {
      width: 50%;
    }

    .block-tab-full .col-block {
      width: 100%;
      clear: both;
    }

    [class*="block-tab-"] .bgrid:nth-child(n) {
      clear: none;
    }

    .block-tab-1-6 .col-block:nth-child(6n+1),
    .block-tab-1-6 .col-block:nth-child(5n+1),
    .block-tab-1-4 .col-block:nth-child(4n+1),
    .block-tab-1-3 .col-block:nth-child(3n+1),
    .block-tab-1-2 .col-block:nth-child(2n+1) {
      clear: both;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## mobile devices - (_grid.scss)
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 600px) {
    .block-mob-1-6 .col-block {
      width: 16.66667%;
    }

    .block-mob-1-5 .col-block {
      width: 20%;
    }

    .block-mob-1-4 .col-block {
      width: 25%;
    }

    .block-mob-1-3 .col-block {
      width: 33.33333%;
    }

    .block-mob-1-2 .col-block {
      width: 50%;
    }

    .block-mob-full .col-block {
      width: 100%;
      clear: both;
    }

    [class*="block-mob-"] .bgrid:nth-child(n) {
      clear: none;
    }

    .block-mob-1-6 .col-block:nth-child(6n+1),
    .block-mob-1-5 .col-block:nth-child(5n+1),
    .block-mob-1-4 .col-block:nth-child(4n+1),
    .block-mob-1-3 .col-block:nth-child(3n+1),
    .block-mob-1-2 .col-block:nth-child(2n+1) {
      clear: both;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## small mobile devices - (_grid.scss) 
 * ------------------------------------------------------------------- */

  /* stack columns on small mobile devices
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 400px) {
    .stack .col-block {
      width: 100% !important;
      float: none !important;
      clear: both !important;
      margin-left: 0;
      margin-right: 0;
    }
  }

  /* ===================================================================
 * # MISC  - (_grid.scss)
 *
 * ------------------------------------------------------------------- */

  .group:after {
    content: "";
    display: table;
    clear: both;
  }

  /* Misc Helper Styles
 * -------------------------------------- */

  .is-hidden {
    display: none;
  }

  .is-invisible {
    visibility: hidden;
  }

  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .remove-bottom {
    margin-bottom: 0;
  }

  .half-bottom {
    margin-bottom: 1.5rem !important;
  }

  .add-bottom {
    margin-bottom: 3rem !important;
  }

  .no-border {
    border: none;
  }

  .full-width {
    width: 100%;
  }

  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .pull-left {
    float: left;
  }

  .pull-right {
    float: right;
  }

  .align-center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  /* =================================================================== 
 *
 *  Hola v1.0 Main Stylesheet
 *  10-02-2017
 *  ------------------------------------------------------------------
 *
 *  TOC:
 *  # webfonts and iconfonts
 *  # base style overrides
 *      ## links
 *  # typography & general theme styles
 *      ## lists
 *      ## responsive video container
 *      ## floated image
 *      ## tables
 *      ## spacing
 *      ## pace.js styles - minimal
 *  # forms
 *      ## style placeholder text
 *      ## Change Autocomplete styles in Chrome
 *  # buttons
 *  # additional components
 *      ## alert box
 *      ## additional typo styles
 *      ## skillbars
 *  # common and reusable theme styles 
 *      ## section intro
 *      ## blog-list
 *  # header styles
 *      ## header logo
 *      ## mobile menu toggle
 *      ## navigation
 *  # home
 *      ## home content
 *      ## home social
 *      ## home animations
 *  # news
 *      ## timeline
 *  # gallery
 *      ## bricks/masonry
 *  # testimonials
 *  # blog
 *  # cta
 *  # stats
 *  # contact
 *  # footer
 *      ## go to top
 *  # blog styles
 *      ## blog page header
 *      ## blog content
 *      ## comments
 *
 * =================================================================== */

  /* ===================================================================
 * # webfonts and iconfonts - (_document-setup.scss)
 * 45.76.9.16
@import url("iconic/css/iconmonstr-iconic-font.min.css");
@import url("fonts.css");
 * ------------------------------------------------------------------- */

  /* ===================================================================
 * # base style overrides - (_document-setup.scss)
 *
 * ------------------------------------------------------------------- */

  html {
    font-size: 10px;
  }

  @media only screen and (max-width: 400px) {
    html {
      font-size: 9.375px;
    }
  }

  html,
  body {
    height: 100%;
  }

  body {
    font-display: swap;
    line-height: 1;
    color: #5f5f5f;
    margin: 0;
    padding: 0;
  }

  body.white {}

  body.dark {}

  /* ------------------------------------------------------------------- 
 * ## links - (_document-setup.scss) 
 * ------------------------------------------------------------------- */

  a {
    color: #862121;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  a:hover,
  a:focus,
  a:active {
    color: #191A3F;
  }

  a:focus {
    outline: none;
  }

  /* ===================================================================
 * # typography & general theme styles - (_document-setup.scss) 
 * 
 * ------------------------------------------------------------------- */

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h01,
  .h02,
  .h03,
  .h04,
  .h05,
  .h06 {
    font-weight: 600;
    font-family: montserrat, sans-serif;
    color: #0D0A0B;
    font-style: normal;
    font-weight: normal;
    text-rendering: optimizeLegibility;
  }

  h1,
  .h01,
  h2,
  .h02,
  h3,
  .h03,
  h4,
  .h04 {
    margin-top: 6rem;
    margin-bottom: 1.8rem;
  }

  @media only screen and (max-width: 600px) {

    h1,
    .h01,
    h2,
    .h02,
    h3,
    .h03,
    h4,
    .h04 {
      margin-top: 5.1rem;
    }
  }

  h5,
  .h05,
  h6,
  .h06 {
    margin-top: 4.2rem;
    margin-bottom: 1.5rem;
  }

  @media only screen and (max-width: 600px) {

    h5,
    .h05,
    h6,
    .h06 {
      margin-top: 3.6rem;
      margin-bottom: 0.9rem;
    }
  }

  h1,
  .h01 {
    font-weight: 700;
    font-family: montserrat, sans-serif;
    font-size: 2.6rem;
    line-height: 1.25;
    letter-spacing: -.1rem;
  }

  @media only screen and (max-width: 600px) {

    h1,
    .h01 {
      font-size: 3.3rem;
      letter-spacing: -.07rem;
    }
  }

  h2,
  .h02 {
    font-size: 3rem;
    line-height: 1.3;
  }

  h3,
  .h03 {
    font-size: 2.4rem;
    line-height: 1.25;
  }

  h4,
  .h04 {
    font-size: 2.1rem;
    line-height: 1.286;
  }

  h5,
  .h05 {
    font-size: 1.6rem;
    line-height: 1.3125;
  }

  h6,
  .h06 {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.4rem;
    line-height: 1.5;
    text-transform: uppercase;
    letter-spacing: .16rem;
  }

  p img {
    margin: 0;
  }

  p.lead {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 2rem;
    line-height: 1.8;
    margin-bottom: 3.6rem;
    color: #0D0A0B;
  }

  @media only screen and (max-width: 800px) {
    p.lead {
      font-size: 1.8rem;
    }
  }

  em,
  i,
  strong,
  b {
    font-size: inherit;
    line-height: inherit;
    font-style: normal;
    font-weight: normal;
  }

  em,
  i {
    font-display: swap;
    font-family: "librebaskerville-italic", serif;
  }

  strong,
  b {}

  small {
    font-size: 1.2rem;
    line-height: inherit;
  }

  blockquote {
    margin: 3.9rem 0;
    padding-left: 4.5rem;
    position: relative;
  }

  blockquote:before {
    content: "\201C";
    font-size: 10rem;
    line-height: 0px;
    margin: 0;
    color: rgba(0, 0, 0, 0.15);
    font-display: swap;
    font-family: arial, sans-serif;
    position: absolute;
    top: 3.6rem;
    left: 0;
  }

  blockquote p {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    padding: 0;
    font-size: 2.1rem;
    line-height: 1.857;
    color: #0D0A0B;
  }

  blockquote cite {
    display: block;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.4rem;
    font-style: normal;
    line-height: 1.5;
  }

  blockquote cite:before {
    content: "\2014 \0020";
  }

  blockquote cite a,
  blockquote cite a:visited {
    color: #6c6c6c;
    border: none;
  }

  abbr {
    font-display: swap;
    font-family: "librebaskerville-bold", serif;
    font-variant: small-caps;
    text-transform: lowercase;
    letter-spacing: .05rem;
    color: #6c6c6c;
  }

  var,
  kbd,
  samp,
  code,
  pre {
    font-display: swap;
    font-family: Consolas, "Andale Mono", Courier, "Courier New", monospace;
  }

  pre {
    padding: 2.4rem 3rem 3rem;
    background: #F1F1F1;
    overflow-x: auto;
  }

  code {
    font-size: 1.4rem;
    margin: 0 .2rem;
    padding: .3rem .6rem;
    white-space: nowrap;
    background: #F1F1F1;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
  }

  pre>code {
    display: block;
    white-space: pre;
    line-height: 2;
    padding: 0;
    margin: 0;
  }

  pre.prettyprint>code {
    border: none;
  }

  del {
    text-decoration: line-through;
  }

  abbr[title],
  dfn[title] {
    border-bottom: 1px dotted;
    cursor: help;
    text-decoration: none;
  }

  mark {
    background: #ffd900;
    color: #000000;
  }

  hr {
    border: solid rgba(0, 0, 0, 0.1);
    border-width: 1px 0 0;
    clear: both;
    margin: 2.4rem 0 1.5rem;
    height: 0;
  }

  /* ------------------------------------------------------------------- 
 * ## Lists - (_document-setup.scss)  
 * ------------------------------------------------------------------- */

  ol {
    list-style: decimal;
  }

  ul {
    list-style: disc;
  }

  li {
    display: list-item;
  }

  ol,
  ul {
    margin-left: 1.7rem;
  }

  ul li {
    padding-left: .4rem;
  }

  ul ul,
  ul ol,
  ol ol,
  ol ul {
    margin: .6rem 0 .6rem 1.7rem;
  }

  ul.disc li {
    display: list-item;
    list-style: none;
    padding: 0 0 0 .8rem;
    position: relative;
  }

  ul.disc li::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #862121;
    position: absolute;
    left: -17px;
    top: 11px;
    vertical-align: middle;
  }

  dt {
    margin: 0;
    color: #862121;
  }

  dd {
    margin: 0 0 0 2rem;
  }

  /* ------------------------------------------------------------------- 
 * ## responsive video container - (_document-setup)
 * ------------------------------------------------------------------- */

  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
  }

  .video-container iframe,
  .video-container object,
  .video-container embed,
  .video-container video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  /* ------------------------------------------------------------------- 
 * ## floated image - (_document-setup)  
 * ------------------------------------------------------------------- */

  img.pull-right {
    margin: 1.5rem 0 0 3rem;
  }

  img.pull-left {
    margin: 1.5rem 3rem 0 0;
  }

  /* ------------------------------------------------------------------- 
 * ## tables - (_document-setup.scss)  
 * ------------------------------------------------------------------- */

  table {
    border-width: 0;
    width: 100%;
    max-width: 100%;
    font-display: swap;
    font-family: "librebaskerville-regular", serif;
  }

  th,
  td {
    padding: 1.5rem 3rem;
    text-align: left;
    border-bottom: 1px solid #E8E8E8;
  }

  th {
    color: #0D0A0B;
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
  }

  td {
    line-height: 1.5;
  }

  th:first-child,
  td:first-child {
    padding-left: 0;
  }

  th:last-child,
  td:last-child {
    padding-right: 0;
  }

  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* ------------------------------------------------------------------- 
 * ## Spacing - (_document-setup.scss)  
 * ------------------------------------------------------------------- */

  button,
  .btn {
    margin-bottom: 1.2rem;
  }

  fieldset {
    margin-bottom: 1.5rem;
  }

  input,
  textarea,
  select,
  pre,
  blockquote,
  figure,
  table,
  p,
  ul,
  ol,
  dl,
  form,
  .video-container,
  .ss-custom-select {
    margin-bottom: 3rem;
  }

  /* ------------------------------------------------------------------- 
 * ## pace.js styles - minimal  - (_document-setup.scss)
 * ------------------------------------------------------------------- */

  .pace {
    -webkit-pointer-events: none;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }

  .pace-inactive {
    display: none;
  }

  .pace .pace-progress {
    background: #862121;
    background: rgb(71, 128, 0);
    position: fixed;
    z-index: 900;
    top: 0;
    right: 100%;
    width: 100%;
    height: 2px;
  }

  .oldie .pace {
    display: none;
  }

  /* ===================================================================
 * preloader - (_preloader-2.scss)
 *
 * ------------------------------------------------------------------- */

  #preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #0F1215;
    background: rgb(242, 242, 242);
    z-index: 800;
    height: 100%;
    width: 100%;
  }

  body.white #preloader {
    background: rgb(242, 242, 242);
  }

  body.dark #preloader {
    background: #232323;
    ;
  }

  .no-js #preloader,
  .oldie #preloader {
    display: none;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    padding: 0;
    background-color: #862121;
    border-radius: 100%;
    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
    animation: sk-scaleout 1.0s infinite ease-in-out;
  }

  @-webkit-keyframes sk-scaleout {
    0% {
      -webkit-transform: scale(0);
    }

    100% {
      -webkit-transform: scale(1);
      opacity: 0;
    }
  }

  @keyframes sk-scaleout {
    0% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 0;
    }
  }

  /* ===================================================================
 * # forms - (_forms.scss)
 *
 * ------------------------------------------------------------------- */

  fieldset {
    border: none;
  }

  /*
input[type="email"], 
input[type="number"], 
input[type="search"], 
input[type="text"], 
input[type="tel"], 
input[type="url"], 
input[type="password"], 
textarea, select {
    display: block;
    height: 6rem;
    padding: 1.5rem 0;
    border: 0;
    outline: none;
    color: #333333;
    font-weight:400;
font-display: swap;
font-family: montserrat, sans-serif;
    font-size: 1.5rem;
    line-height: 3rem;
    max-width: 100%;
    background: transparent;
    border-bottom: 2px solid rgba(0, 0, 0, 0.15);
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
*/

  .ss-custom-select {
    position: relative;
    padding: 0;
  }

  .ss-custom-select select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    text-indent: 0.01px;
    text-overflow: '';
    margin: 0;
    line-height: 3rem;
    vertical-align: middle;
  }

  .ss-custom-select select option {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .ss-custom-select select::-ms-expand {
    display: none;
  }

  .ss-custom-select::after {
    border-bottom: 2px solid rgba(0, 0, 0, 0.5);
    border-right: 2px solid rgba(0, 0, 0, 0.5);
    content: '';
    display: block;
    height: 8px;
    width: 8px;
    margin-top: -7px;
    pointer-events: none;
    position: absolute;
    right: 2.4rem;
    top: 50%;
    -webkit-transform-origin: 66% 66%;
    -ms-transform-origin: 66% 66%;
    transform-origin: 66% 66%;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
  }

  /* IE9 and below */

  .oldie .ss-custom-select::after {
    display: none;
  }

  textarea {
    min-height: 25rem;
  }

  input[type="email"]:focus,
  input[type="number"]:focus,
  input[type="search"]:focus,
  input[type="text"]:focus,
  input[type="tel"]:focus,
  input[type="url"]:focus,
  input[type="password"]:focus,
  textarea:focus,
  select:focus {
    color: #000000;
    border-bottom: 2px solid black;
  }

  label,
  legend {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.4rem;
    margin-bottom: .9rem;
    line-height: 1.714;
    color: #0D0A0B;
    display: block;
  }

  input[type="checkbox"],
  input[type="radio"] {
    display: inline;
  }

  label>.label-text {
    display: inline-block;
    margin-left: 1rem;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    line-height: inherit;
  }

  label>input[type="checkbox"],
  label>input[type="radio"] {
    margin: 0;
    position: relative;
    top: .15rem;
  }

  /* ------------------------------------------------------------------- 
 * ## style placeholder text - (_forms.scss)
 * ------------------------------------------------------------------- */

  ::-webkit-input-placeholder {
    color: #6c6c6c;
  }

  :-moz-placeholder {
    color: #6c6c6c;
    /* Firefox 18- */
  }

  ::-moz-placeholder {
    color: #6c6c6c;
    /* Firefox 19+ */
  }

  :-ms-input-placeholder {
    color: #6c6c6c;
  }

  .placeholder {
    color: #6c6c6c !important;
  }

  /* ------------------------------------------------------------------- 
 * ## Change Autocomplete styles in Chrome - (_forms.scss)
 * ------------------------------------------------------------------- */

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus input:-webkit-autofill,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: #cf3e3e;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* ===================================================================
 * # buttons - (_buttons.scss)
 *
 * ------------------------------------------------------------------- */
  .home-content .btn,
  .home-content button,
  .home-content input[type="submit"],
  .home-content input[type="reset"],
  .home-content input[type="button"] {
    display: inline-block;
    font-weight: 600;
    font-display: swap;
    font-family: Lato, sans-serif;
    font-size: 1.2rem;
    text-transform: uppercase;
    letter-spacing: .3rem;
    /*height: 5.4rem;*/
    line-height: calc(5.4rem - .6rem);
    padding: 0 3rem;
    margin: 0 .3rem 1.2rem 0;
    color: #151515;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    background-color: #c5c5c5;
    border: .3rem solid #c5c5c5;
  }

  /* button primary
 * ------------------------------------------------- */

  /* button modifiers
 * ------------------------------------------------- */

  .btn.full-width,
  button.full-width {
    width: 100%;
    margin-right: 0;
  }

  .btn--medium,
  button.btn--medium {
    height: 5.7rem !important;
    line-height: calc(5.7rem - .6rem) !important;
  }

  .btn--large,
  button.btn--large {
    height: 6rem !important;
    line-height: calc(6rem - .6rem) !important;
  }

  .btn--stroke,
  button.btn--stroke {
    background: transparent !important;
    border: 0.3rem solid #000000;
    color: #000000;
  }

  .btn--stroke:hover,
  button.btn--stroke:hover {
    border: 0.3rem solid #862121;
    color: #862121;
  }

  .btn--pill,
  button.btn--pill {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
    border-radius: 1000px !important;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  /* =================================================================== 
 * # additional components - (_others.scss)
 *
 * ------------------------------------------------------------------- */

  /* ------------------------------------------------------------------- 
 * ## alert box - (_alert-box.scss)
 * ------------------------------------------------------------------- */

  .alert-box {
    padding: 2.1rem 4rem 2.1rem 3rem;
    position: relative;
    margin-bottom: 3rem;
    border-radius: 3px;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.5rem;
    line-height: 1.6;
  }

  .alert-box__close {
    position: absolute;
    right: 1.8rem;
    top: 1.8rem;
    cursor: pointer;
  }

  .alert-box__close.im {
    font-size: 12px;
  }

  .alert-box--error {
    background-color: #ffd1d2;
    color: #e65153;
  }

  .alert-box--success {
    background-color: #c8e675;
    color: #758c36;
  }

  .alert-box--info {
    background-color: #d7ecfb;
    color: #4a95cc;
  }

  .alert-box--notice {
    background-color: #fff099;
    color: #bba31b;
  }

  /* ------------------------------------------------------------------- 
 * ## additional typo styles - (_additional-typo.scss)
 * ------------------------------------------------------------------- */

  /* drop cap 
 * ----------------------------------------------- */

  .drop-cap:first-letter {
    float: left;
    margin: 0;
    padding: 1.5rem .6rem 0 0;
    font-size: 8.4rem;
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    line-height: 6rem;
    text-indent: 0;
    background: transparent;
    color: #000000;
  }

  /* line definition style 
 * ----------------------------------------------- */

  .lining dt,
  .lining dd {
    display: inline;
    margin: 0;
  }

  .lining dt+dt:before,
  .lining dd+dt:before {
    content: "\A";
    white-space: pre;
  }

  .lining dd+dd:before {
    content: ", ";
  }

  .lining dd+dd:before {
    content: ", ";
  }

  .lining dd:before {
    content: ": ";
    margin-left: -0.2em;
  }

  /* dictionary definition style 
 * ----------------------------------------------- */

  .dictionary-style dt {
    display: inline;
    counter-reset: definitions;
  }

  .dictionary-style dt+dt:before {
    content: ", ";
    margin-left: -0.2em;
  }

  .dictionary-style dd {
    display: block;
    counter-increment: definitions;
  }

  .dictionary-style dd:before {
    content: counter(definitions, decimal) ". ";
  }

  /** 
 * Pull Quotes
 * -----------
 * markup:
 *
 * <aside class="pull-quote">
 *		<blockquote>
 *			<p></p>
 *		</blockquote>
 *	</aside>
 *
 * --------------------------------------------------------------------- */

  .pull-quote {
    position: relative;
    padding: 2.1rem 3rem 2.1rem 0px;
  }

  .pull-quote:before,
  .pull-quote:after {
    height: 1em;
    position: absolute;
    font-size: 10rem;
    font-display: swap;
    font-family: Arial, Sans-Serif;
    color: rgba(0, 0, 0, 0.15);
  }

  .pull-quote:before {
    content: "\201C";
    top: -3.6rem;
    left: 0;
  }

  .pull-quote:after {
    content: '\201D';
    bottom: 3.6rem;
    right: 0;
  }

  .pull-quote blockquote {
    margin: 0;
  }

  .pull-quote blockquote:before {
    content: none;
  }

  /** 
 * Stats Tab
 * ---------
 * markup:
 *
 * <ul class="stats-tabs">
 *		<li><a href="#">[value]<em>[name]</em></a></li>
 *	</ul>
 *
 * Extend this object into your markup.
 *
 * --------------------------------------------------------------------- */

  .stats-tabs {
    padding: 0;
    margin: 3rem 0;
  }

  .stats-tabs li {
    display: inline-block;
    margin: 0 1.5rem 3rem 0;
    padding: 0 1.5rem 0 0;
    border-right: 1px solid rgba(13, 10, 11, 0.15);
  }

  .stats-tabs li:last-child {
    margin: 0;
    padding: 0;
    border: none;
  }

  .stats-tabs li a {
    display: inline-block;
    font-size: 2.5rem;
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    border: none;
    color: #151515;
  }

  .stats-tabs li a:hover {
    color: #862121;
  }

  .stats-tabs li a em {
    display: block;
    margin: .6rem 0 0 0;
    font-size: 1.4rem;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    color: #6c6c6c;
  }

  /* ------------------------------------------------------------------- 
 * ## skillbars - (_skillbars.scss)
 * ------------------------------------------------------------------- */

  .skill-bars {
    list-style: none;
    margin: 6rem 0 3rem;
  }

  .skill-bars li {
    height: .6rem;
    background: #c9c9c9;
    width: 100%;
    margin-bottom: 6.9rem;
    padding: 0;
    position: relative;
  }

  .skill-bars li strong {
    position: absolute;
    left: 0;
    top: -3rem;
    font-display: swap;
    font-family: "montserrat-extrabold", sans-serif;
    color: #0D0A0B;
    text-transform: uppercase;
    letter-spacing: .2rem;
    font-size: 1.4rem;
    line-height: 2.4rem;
  }

  .skill-bars li .progress {
    background: #000000;
    background-image: linear-gradient(to right, #191A3F, #2d462c);
    position: relative;
    height: 100%;
  }

  .skill-bars li .progress span {
    position: absolute;
    right: 0;
    top: -3.6rem;
    display: block;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    color: #FFFFFF;
    font-size: 1.1rem;
    line-height: 1;
    background: #000000;
    padding: .6rem .6rem;
    border-radius: 3px;
  }

  .skill-bars li .progress span::after {
    position: absolute;
    left: 50%;
    bottom: -5px;
    margin-left: -5px;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-top: 5px solid #000000;
    content: "";
  }

  .skill-bars li .percent5 {
    width: 5%;
  }

  .skill-bars li .percent10 {
    width: 10%;
  }

  .skill-bars li .percent15 {
    width: 15%;
  }

  .skill-bars li .percent20 {
    width: 20%;
  }

  .skill-bars li .percent25 {
    width: 25%;
  }

  .skill-bars li .percent30 {
    width: 30%;
  }

  .skill-bars li .percent35 {
    width: 35%;
  }

  .skill-bars li .percent40 {
    width: 40%;
  }

  .skill-bars li .percent45 {
    width: 45%;
  }

  .skill-bars li .percent50 {
    width: 50%;
  }

  .skill-bars li .percent55 {
    width: 55%;
  }

  .skill-bars li .percent60 {
    width: 60%;
  }

  .skill-bars li .percent65 {
    width: 65%;
  }

  .skill-bars li .percent70 {
    width: 70%;
  }

  .skill-bars li .percent75 {
    width: 75%;
  }

  .skill-bars li .percent80 {
    width: 80%;
  }

  .skill-bars li .percent85 {
    width: 85%;
  }

  .skill-bars li .percent90 {
    width: 90%;
  }

  .skill-bars li .percent95 {
    width: 95%;
  }

  .skill-bars li .percent100 {
    width: 100%;
  }

  /* ===================================================================
 * # common and reusable theme styles  - (_common-styles.scss)
 *
 * ------------------------------------------------------------------- */

  .wide {
    max-width: 1400px;
  }

  .narrow {
    max-width: 800px;
  }

  /* ------------------------------------------------------------------- 
 * ## section intro - (_common-styles.scss)
 * ------------------------------------------------------------------- */

  .section-intro {
    text-align: center;
    position: relative;
  }

  .section-intro h1 {
    font-display: swap;
    font-family: "librebaskerville-bold", serif;
    font-size: 4.8rem;
    line-height: 1.375;
    margin-top: 0;
  }

  .section-intro h3 {
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 2rem;
    color: #862121;
    text-transform: uppercase;
    letter-spacing: .15rem;
    margin-top: 0;
    margin-bottom: 0;
  }

  .section-intro.has-bottom-sep {
    padding-bottom: 1.5rem;
    position: relative;
  }

  .section-intro.has-bottom-sep::after {
    display: inline-block;
    height: 1px;
    width: 240px;
    background-color: rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * section-intro
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 800px) {
    .section-intro h1 {
      font-size: 4.2rem;
    }

    .section-intro h3 {
      font-size: 1.8rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .section-intro h1 {
      font-size: 3.6rem;
    }

    .section-intro h3 {
      font-size: 1.7rem;
    }
  }

  @media only screen and (max-width: 400px) {
    .section-intro h1 {
      font-size: 3.3rem;
    }

    .section-intro h3 {
      font-size: 1.6rem;
    }
  }

  /* ------------------------------------------------------------------- 
 * ## blog-list - (_common-styles.scss)
 * ------------------------------------------------------------------- */

  .blog-list {
    margin-top: 6rem;
    margin-left: 0;
  }

  .blog-list article {
    margin-bottom: 7.2rem;
  }

  .blog-list article:nth-child(2n+1) {
    padding-right: 50px;
  }

  .blog-list article:nth-child(2n+2) {
    padding-left: 50px;
  }

  .blog-list h2 {
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 3rem;
    line-height: 1.2;
    margin-top: .3rem;
    margin-bottom: 2.1rem;
    padding-bottom: 2.4rem;
    color: #0D0A0B;
    position: relative;
  }

  .blog-list h2 a {
    color: #0D0A0B;
  }

  .blog-list h2::after {
    display: block;
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 80px;
    background-color: rgba(0, 0, 0, 0.15);
  }

  .blog-list .blog-date {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.5rem;
    color: #862121;
  }

  .blog-list .blog-date a {
    color: #862121;
  }

  .blog-list .blog-date a:hover,
  .blog-list .blog-date a:focus,
  .blog-list .blog-date a:active {
    color: #000000;
  }

  .blog-list .blog-cat {
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.3rem;
    text-transform: uppercase;
    letter-spacing: .2rem;
    color: #000000;
    margin-top: -.9rem;
  }

  .blog-list .blog-cat a {
    color: #000000;
  }

  .blog-list .blog-cat a:hover,
  .blog-list .blog-cat a:focus,
  .blog-list .blog-cat a:active {
    color: #862121;
  }

  .blog-list .blog-cat a::after {
    content: ", ";
  }

  .blog-list .blog-cat a:last-child::after {
    display: none;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * blog-list
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .blog-list article:nth-child(2n+1) {
      padding-right: 40px;
    }

    .blog-list article:nth-child(2n+2) {
      padding-left: 40px;
    }
  }

  @media only screen and (max-width: 800px) {
    .blog-list article:nth-child(n) {
      padding: 0 15px;
    }
  }

  @media only screen and (max-width: 600px) {
    .blog-list article:nth-child(n) {
      padding: 0;
    }

    .blog-list h2 {
      font-size: 2.7rem;
    }
  }

  /* ===================================================================
 * # home - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-home {
    width: 100%;
    height: 100%;
    min-height: 786px;
    background-color: transparent;
    position: relative;
    display: table;
  }

  .s-home .shadow-overlay {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .8;
    background: -moz-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    background: -webkit-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#cc000000', GradientType=0);
  }

  .s-home .overlay {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background-color: #111111;
  }

  .no-js .s-home {
    background: #0D0A0B;
  }

  /* ------------------------------------------------------------------- 
 * ## home content - (_site-layout.scss) 
 * ------------------------------------------------------------------- */

  .home-content {
    display: table-cell;
    width: 100%;
    height: 100%;
    vertical-align: bottom;
    /*padding-bottom: 19.2rem;*/
    padding-bottom: 200px;
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .home-content h3 {
    font-weight: 700;
    font-display: swap;
    font-family: Lato, sans-serif;
    font-size: 1.8rem;
    color: #862121;
    color: orange;
    text-transform: uppercase;
    letter-spacing: .3rem;
    position: relative;
    padding-left: 80px;
    margin-left: -30px;
    margin-bottom: .6rem;
  }

  .home-content h3::before {
    display: block;
    content: "";
    width: 60px;
    height: 2px;
    background-color: #862121;
    margin-top: -1.5px;
    position: absolute;
    left: 0;
    top: 50%;
  }

  .home-content__main #subheaders h1 {
    font-size: 3.75rem;
    word-spacing: 1px;
  }

  .home-content h1 {
    font-display: swap;
    font-family: Lato, sans-serif;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 3.75rem;
    line-height: 1;
    margin-bottom: -52px;
    margin-top: 0;
  }

  .home-content__main {
    padding-right: 300px;
    position: relative;
  }

  .home-content__buttons {
    position: absolute;
    right: 0;
    bottom: 2.1rem;
    text-align: center;
  }

  .home-content__buttons .btn {
    display: block;
    width: 210px;
    border-color: #FFFFFF;
    color: #FFFFFF;
    margin: 1.5rem 0 0 0;
    letter-spacing: .25rem;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  .home-content__buttons .btn:hover,
  .home-content__buttons .btn:focus {
    background: #FFFFFF !important;
    color: #000000;
  }

  .home-content__scroll {
    position: absolute;
    left: .6rem;
    bottom: -13.2rem;
  }

  .home-content__scroll a {
    font-weight: 600;
    font-display: swap;
    font-family: Lato, sans-serif;
    font-size: 1.1rem;
    text-transform: uppercase;
    letter-spacing: .3rem;
    color: #FFFFFF;
    position: relative;
    display: inline-block;
    line-height: 3rem;
    padding-right: 2rem;
  }

  .home-content__scroll a::after {
    border-bottom: 2px solid #922424;
    border-right: 2px solid #922424;
    content: '';
    display: block;
    height: 8px;
    width: 8px;
    margin-top: -7px;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 50%;
    -webkit-transform-origin: 66% 66%;
    -ms-transform-origin: 66% 66%;
    transform-origin: 66% 66%;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
  }

  /* ------------------------------------------------------------------- 
 * ## home social - (_site-layout.scss) 
 * ------------------------------------------------------------------- */

  .home-social {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    list-style: none;
    margin: 0;
    padding-bottom: 18rem;
    position: absolute;
    bottom: 0;
    right: 40px;
  }

  .home-social::after {
    display: block;
    content: "";
    height: 17.4rem;
    width: 1px;
    background-color: rgba(255, 255, 255, 0.08);
    position: absolute;
    bottom: 0;
    right: .75rem;
  }

  .home-social a {
    color: white;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  .home-social li {
    position: relative;
    height: 3.6rem;
  }

  .home-social i,
  .home-social span {
    position: absolute;
    top: 0;
    line-height: 3.6rem;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  .home-social i {
    font-size: 1.8rem;
    right: 0;
    -webkit-transform: scale(0.7);
    -ms-transform: scale(0.7);
    transform: scale(0.7);
  }

  .home-social span {
    color: #af2b2b;
    right: 3.6rem;
    font-size: 1.3rem;
    opacity: 0;
    visibility: hidden;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 50%;
    -ms-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
  }

  .home-social li:hover span {
    opacity: 1;
    visibility: visible;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  .home-social li:hover i {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  /* animate .home-content__main
 * ------------------------------------------------------------------- */

  html.ss-preload .home-content__main {
    opacity: 0;
  }

  html.ss-loaded .home-content__main {
    animation-duration: 2s;
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  html.no-csstransitions .home-content__main {
    opacity: 1;
  }

  /* ------------------------------------------------------------------- 
 * ## home animations - (_site-layout.scss) 
 * ------------------------------------------------------------------- */

  /* bounce */

  @-webkit-keyframes bounce {

    0%,
    100% {
      -webkit-transform: translate3d(0, -30px, 0);
      -ms-transform: translate3d(0, -30px, 0);
      transform: translate3d(0, -30px, 0);
    }

    50% {
      -webkit-transform: translate3d(0, -4px, 0);
      -ms-transform: translate3d(0, -4px, 0);
      transform: translate3d(0, -4px, 0);
    }
  }

  @keyframes bounce {

    0%,
    100% {
      -webkit-transform: translate3d(0, -30px, 0);
      -ms-transform: translate3d(0, -30px, 0);
      transform: translate3d(0, -30px, 0);
    }

    50% {
      -webkit-transform: translate3d(0, -4px, 0);
      -ms-transform: translate3d(0, -4px, 0);
      transform: translate3d(0, -4px, 0);
    }
  }

  /* fade in */

  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -150%, 0);
      -ms-transform: translate3d(0, -150%, 0);
      transform: translate3d(0, -150%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -150%, 0);
      -ms-transform: translate3d(0, -150%, 0);
      transform: translate3d(0, -150%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  /* fade out */

  @-webkit-keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d(0, -150%, 0);
      -ms-transform: translate3d(0, -150%, 0);
      transform: translate3d(0, -150%, 0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d(0, -150%, 0);
      -ms-transform: translate3d(0, -150%, 0);
      transform: translate3d(0, -150%, 0);
    }
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * home
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1500px) {
    .home-content h1 {
      font-size: 5.2rem;
    }

    .home-content__main {
      max-width: 1000px;
    }
  }

  @media only screen and (max-width: 1200px) {
    .home-content h1 {
      font-size: 5rem;
    }

    .home-content br {
      display: none;
    }

    .home-content__main {
      max-width: 800px;
    }

    .home-content__buttons {
      right: 30px;
    }
  }

  @media only screen and (max-width: 1000px) {
    .home-content h1 {
      font-size: 4.8rem;
    }

    .home-content__main {
      padding-right: 40px;
      max-width: 680px;
    }

    .home-content__buttons {
      position: static;
      text-align: left;
    }

    .home-content__buttons .btn {
      display: inline-block;
      margin-right: .9rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .home-content h3 {
      font-size: 1.6rem;
      padding-left: 50px;
      margin-left: -10px;
    }

    .home-content h3::before {
      width: 40px;
    }

    .home-content h1 {
      font-size: 4.4rem;
    }

    .home-content__main {
      max-width: 500px;
    }
  }

  body.isMobile .home-content .home-content__main {
    top: 80px;
    padding-right: unset;
  }

  body.isMobile .home-content #subheaders {
    margin-bottom: 50px;
    margin-left: 1.5rem;
  }

  body.isMobile .home-content h1 {
    font-size: 2.2rem;
  }

  body.isMobile .home-content .row.home-content__teasers {
    margin-top: -50px;
  }

  body.isMobile .home-content__buttons {
    position: relative;
    text-align: center;
    display: block;
    width: 100%;
    right: unset;
    margin-top: 50px;
  }

  body.isMobile .home-content__scroll {
    margin-left: 1.5rem;
  }

  body.isMobile #app .home-content__buttons .btn {
    display: inline-flex !important
  }

  /* ===================================================================
 * # news - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-news {
    padding-top: 15rem;
    padding-bottom: 9rem;
    background-color: #FFFFFF;
    position: relative;
  }

  .news-content {
    margin-bottom: 3rem;
  }

  .news-content .left {
    padding-right: 40px;
  }

  .news-content .right {
    padding-left: 40px;
  }

  /* ------------------------------------------------------------------- 
 * ## timeline - (_site-layout.scss) 
 * ------------------------------------------------------------------- */

  .timeline {
    position: relative;
    text-align: left;
    margin-top: 3.6rem;
  }

  .timeline::before {
    content: "";
    display: block;
    width: 1px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 2rem;
    top: 0;
  }

  .timeline__block {
    position: relative;
    padding-left: 8rem;
    min-height: 28.8rem;
  }

  .timeline__bullet {
    background: #0D0A0B;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
    margin-left: -0.75rem;
    box-shadow: 0 0 0 9px #E9E9E9;
    position: absolute;
    left: 2rem;
    top: .3rem;
  }

  .timeline__header .timeline__timeframe {
    font-size: 1.4rem;
    line-height: 1.5;
    text-transform: uppercase;
    letter-spacing: .15rem;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: .9rem;
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
  }

  .timeline__header h3 {
    line-height: 1.25;
    margin: 0 0 .3rem 0;
  }

  .timeline__header h5 {
    margin-top: 0;
  }

  .timeline__desc p {
    margin: 0;
    padding-bottom: 3rem;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * news
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1000px) {
    .news-content .left {
      padding-right: 30px;
    }

    .news-content .right {
      padding-left: 30px;
    }
  }

  @media only screen and (max-width: 900px) {
    .news-content .left {
      padding-right: 20px;
    }

    .news-content .right {
      padding-left: 20px;
    }
  }

  @media only screen and (max-width: 800px) {
    .news-content {
      max-width: 600px;
    }

    .news-content .left {
      padding-right: 15px;
    }

    .news-content .right {
      padding-left: 15px;
    }

    .news-content .right .timeline {
      margin-top: 0;
    }

    .news-content .left>h3,
    .news-content .right>h3 {
      text-align: center;
    }
  }

  @media only screen and (max-width: 600px) {
    .news-content .left {
      padding-right: 10px;
    }

    .news-content .right {
      padding-left: 10px;
    }

    .timeline__block {
      padding-left: 6rem;
    }
  }

  @media only screen and (max-width: 400px) {
    .news-content .left {
      padding-right: 0;
    }

    .news-content .right {
      padding-left: 0;
    }

    .timeline__block {
      padding-left: 5.5rem;
    }
  }

  /* ===================================================================
 * # gallery - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-gallery {
    padding-top: 15rem;
    padding-bottom: 15.6rem;
    background-color: #f1f1f1;
    position: relative;
  }

  /* ------------------------------------------------------------------- 
 * ## bricks/masonry - (_site-layout.scss)
 * ------------------------------------------------------------------- */

  .masonry-wrap {
    margin-top: 4.8rem;
    max-width: none;
    width: 1600px;
  }

  .masonry:after {
    content: "";
    display: table;
    clear: both;
  }

  .masonry .grid-sizer,
  .masonry__brick {
    width: 400px;
  }

  .masonry__brick {
    float: left;
    padding: 0;
  }

  .item-folio {
    position: relative;
    overflow: hidden;
  }

  .item-folio__thumb img {
    vertical-align: top;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }

  .item-folio__thumb .shadow-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .8;
    background: -moz-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    background: -webkit-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#cc000000', GradientType=0);
  }

  .item-folio__thumb a {
    display: block;
  }

  .item-folio__thumb a::before {
    display: block;
    background-color: rgba(0, 0, 0, 0.8);
    content: "";
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    z-index: 1;
  }

  .item-folio__thumb a::after {
    content: "...";
    font-display: swap;
    font-family: georgia, serif;
    font-size: 3rem;
    display: block;
    height: 30px;
    width: 30px;
    line-height: 30px;
    margin-left: -15px;
    margin-top: -15px;
    position: absolute;
    left: 50%;
    top: 50%;
    text-align: center;
    color: #FFFFFF;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-transform: scale(0.5);
    -ms-transform: scale(0.5);
    transform: scale(0.5);
    z-index: 1;
  }

  .item-folio__text {
    position: absolute;
    left: 0;
    bottom: 3rem;
    padding: 0 3rem;
    z-index: 2;
  }

  .item-folio__title {
    color: #FFFFFF;
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: .2rem;
    margin: 0;
  }

  .item-folio__cat {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  .item-folio__caption {
    display: none;
  }

  .item-folio__project-link {
    display: block;
    color: #FFFFFF;
    box-shadow: 0 0 0 1px #FFFFFF;
    border-radius: 50%;
    height: 4.2rem;
    width: 4.2rem;
    text-align: center;
    z-index: 500;
    position: absolute;
    top: 3rem;
    left: 3rem;
    opacity: 0;
    visibility: hidden;
    -webkit-transform: translate3d(-100%, 0, 0);
    -ms-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  .item-folio__project-link i {
    font-size: 1.8rem;
    line-height: 4.2rem;
  }

  .item-folio__project-link::before {
    display: block;
    content: "";
    height: 1px;
    width: 3rem;
    background-color: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 50%;
    left: -3rem;
  }

  .item-folio__project-link:hover,
  .item-folio__project-link:focus,
  .item-folio__project-link:active {
    background-color: #FFFFFF;
    color: #000000;
  }

  /* on hover */

  .item-folio:hover .item-folio__thumb a::before {
    opacity: 1;
    visibility: visible;
  }

  .item-folio:hover .item-folio__thumb a::after {
    opacity: 1;
    visibility: visible;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  .item-folio:hover .item-folio__thumb img {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }

  .item-folio:hover .item-folio__project-link {
    opacity: 1;
    visibility: visible;
    -webkit-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * gallery
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1700px) {
    .masonry-wrap {
      width: 1400px;
    }

    .masonry .grid-sizer,
    .masonry__brick {
      width: 350px;
    }
  }

  @media only screen and (max-width: 1500px) {
    .masonry-wrap {
      width: 1200px;
    }

    .masonry .grid-sizer,
    .masonry__brick {
      width: 400px;
    }
  }

  @media only screen and (max-width: 1300px) {
    .masonry-wrap {
      width: 999px;
    }

    .masonry .grid-sizer,
    .masonry__brick {
      width: 333px;
    }
  }

  @media only screen and (max-width: 1099px) {
    .masonry-wrap {
      width: 90%;
      max-width: 800px;
    }

    .masonry .grid-sizer,
    .masonry__brick {
      width: 50%;
    }
  }

  @media only screen and (max-width: 600px) {

    .masonry .grid-sizer,
    .masonry__brick {
      width: 100%;
    }
  }

  @media only screen and (max-width: 400px) {
    .masonry-wrap {
      width: auto;
    }
  }

  /* ===================================================================
 * # testimonials - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-testimonials {
    background-color: #0D0A0B;
    background-repeat: no-repeat;
    background-position: center, center;
    padding-top: 9.6rem;
    padding-bottom: 10.2rem;
    color: rgba(255, 255, 255, 0.5);
    position: relative;
  }

  .s-testimonials .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .85;
    background-color: #0D0A0B;
  }

  .testimonials-header {
    text-align: center;
    padding: 0 14rem;
    position: relative;
  }

  .testimonials-header h1 {
    font-display: swap;
    font-family: "librebaskerville-bold", serif;
    font-size: 4.2rem;
    margin-top: 0;
    color: #FFFFFF;
  }

  .testimonials {
    margin-top: 4.2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
  }

  .testimonials__slider {
    position: relative;
  }

  .testimonials__slider .slick-slide {
    outline: none;
  }

  .testimonials__slider .slick-arrow {
    position: absolute;
    top: -10.2rem;
    color: white;
    border-radius: 100%;
    padding-right: 0;
    padding-left: 0;
    background-color: rgba(255, 255, 255, 0.15);
    border: none;
    box-shadow: 0 0 0 5px rgba(255, 255, 255, 0);
    cursor: pointer;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    z-index: 2;
  }

  .testimonials__slider .slick-arrow .im {
    font-size: 1.2rem;
    height: 4.5rem;
    width: 4.5rem;
    line-height: 4.5rem;
    text-align: center;
  }

  .testimonials__slider .slick-arrow:hover,
  .testimonials__slider .slick-arrow:focus {
    color: white;
    box-shadow: 0 0 0 5px white;
    background-color: transparent;
  }

  .testimonials__slider .slick-prev {
    left: 4.5rem;
  }

  .testimonials__slider .slick-next {
    right: 4.5rem;
  }

  .testimonials__slider .slick-dots {
    display: block;
    list-style: none;
    width: 100%;
    padding: 0;
    margin: 1.5rem 0 0 0;
    text-align: center;
    position: absolute;
    top: 100%;
    left: 0;
  }

  .testimonials__slider .slick-dots li {
    display: inline-block;
    width: 27px;
    height: 27px;
    margin: 0;
    padding: 9px;
    cursor: pointer;
  }

  .testimonials__slider .slick-dots li button {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #959595;
    border: none;
    line-height: 10px;
    padding: 0;
    margin: 0;
    cursor: pointer;
    font: 0/0 a;
    text-shadow: none;
    color: transparent;
  }

  .testimonials__slider .slick-dots li button:hover,
  .testimonials__slider .slick-dots li button:focus {
    outline: none;
  }

  .testimonials__slider .slick-dots li.slick-active button,
  .testimonials__slider .slick-dots li:hover button {
    background: #375636;
  }

  .testimonials__slide {
    position: relative;
    padding-top: 4.5rem;
    padding-left: 12rem;
    padding-right: 3rem;
    line-height: 2.063;
  }

  .testimonials__slide::before {
    content: "";
    display: block;
    width: 1px;
    height: 3rem;
    position: absolute;
    left: calc(3.3rem + .9rem);
    top: 0;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .testimonials__avatar {
    width: 6.6rem;
    height: 6.6rem;
    box-shadow: 0 0 0 0.9rem rgba(255, 255, 255, 0.1);
    border-radius: 100%;
    position: absolute;
    left: .9rem;
    top: 4.8rem;
    outline: none;
  }

  .testimonials__author {
    margin-top: 0rem;
    color: #FFFFFF;
  }

  .testimonials__author span {
    display: block;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.3rem;
    color: rgba(95, 95, 95, 0.7);
    text-transform: none;
    letter-spacing: 0;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * testimonials
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .testimonials-header h1 {
      font-size: 3.8rem;
    }
  }

  @media only screen and (max-width: 1000px) {
    .testimonials__slide {
      padding-left: 11rem;
    }

    .testimonials__avatar {
      width: 6rem;
      height: 6rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .testimonials-header h1 {
      font-size: 3rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .testimonials {
      margin-top: 3rem;
    }

    .testimonials__slider .slick-arrow {
      top: 5.1rem;
    }

    .testimonials__slider .slick-prev {
      left: 1rem;
    }

    .testimonials__slider .slick-next {
      right: 1rem;
    }

    .testimonials-header {
      padding: 0;
    }

    .testimonials-header h1 {
      font-size: 2.7rem;
    }

    .testimonials__slide {
      padding: 13.2rem 0 0;
      text-align: center;
    }

    .testimonials__slide::before {
      left: 50%;
    }

    .testimonials__avatar {
      left: 50%;
      margin-left: -3rem;
    }
  }

  /* ===================================================================
 * # blog - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-blog {
    padding-top: 15rem;
    padding-bottom: 9.6rem;
    background-color: #FFFFFF;
    position: relative;
  }

  /* ===================================================================
 * # cta - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-cta {
    margin-top: -9rem;
    padding-top: 0;
    padding-bottom: 9rem;
    background-color: #FFFFFF;
    position: relative;
    z-index: 1;
  }

  .cta__content {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .cta__content h2 a {
    color: #0D0A0B;
  }

  .cta__content span {
    color: #191A3F;
  }

  /* ===================================================================
 * # stats - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-stats {
    background-color: #f1f1f1;
    text-align: center;
  }

  .stats__col {
    padding: 7.8rem 2rem 6.6rem;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
  }

  .stats__upsign {
    position: absolute;
    top: 3rem;
    left: 3rem;
    text-align: left;
  }

  .stats__upsign i {
    font-size: 2.1rem;
    line-height: 1;
    color: #cf3e3e;
    color: #008C2C;
  }

  .stats__count {
    font-display: swap;
    font-family: "librebaskerville-bold", serif;
    font-size: 7.2rem;
    line-height: 1;
    color: #0D0A0B;
    padding-bottom: 1.5rem;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .stats__count::after {
    content: "";
    display: block;
    height: 1px;
    width: 100px;
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -50px;
  }

  .stats h4 {
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    margin-top: 1.8rem;
    color: rgba(0, 0, 0, 0.4);
    font-size: 1.8rem;
    position: relative;
  }

  .stats__col--highlight {
    background: #111111 url("/images/count-bg.jpg");
    background-size: 175px 175px;
    position: relative;
  }

  .stats__col--highlight::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .6;
    background-image: linear-gradient(to bottom, rgba(13, 10, 11, 0) 0%, #0D0A0B 100%);
  }

  .stats__col--highlight .stats__count {
    color: #FFFFFF;
  }

  .stats__col--highlight .stats__count::after {
    background-color: #862121;
  }

  .stats__col--highlight h4 {
    color: rgba(255, 255, 255, 0.4);
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * stats
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .stats__count {
      font-size: 5.8rem;
    }

    .stats h4 {
      font-size: 1.6rem;
    }
  }

  @media only screen and (max-width: 1000px) {
    .stats__count {
      font-size: 5rem;
    }

    .stats h4 {
      font-size: 1.4rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .stats__count {
      font-size: 7.2rem;
    }

    .stats h4 {
      font-size: 1.8rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .s-stats {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }

    .stats__col {
      padding: 4.8rem 2rem 4.2rem;
    }
  }

  /* ===================================================================
 * # contact - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  .s-contact {
    background-color: #151515;
    background-image: url("/images/contact-bg.jpg");
    background-repeat: no-repeat;
    background-position: center, center;
    padding-top: 13.2rem;
    padding-bottom: 12rem;
    color: rgba(255, 255, 255, 0.5);
    position: relative;
  }

  .s-contact .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .75;
    background-color: #070606;
  }

  .s-contact .section-intro h1 {
    color: #FFFFFF;
  }

  .s-contact .section-intro p {
    color: rgba(255, 255, 255, 0.5);
  }

  .s-contact .section-intro.has-bottom-sep::after {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .s-contact .form-field {
    position: relative;
  }

  .s-contact .form-field:after {
    content: "";
    display: table;
    clear: both;
  }

  .s-contact .form-field label {
    font-weight: 600;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.1rem;
    line-height: 2.4rem;
    position: absolute;
    bottom: -0.3rem;
    right: .6rem;
    text-transform: uppercase;
    letter-spacing: .1rem;
    padding: 0 2rem;
    margin: 0;
    color: #FFFFFF;
    background: #862121;
  }

  .s-contact .form-field label::after {
    content: "";
    position: absolute;
    left: -5px;
    top: 50%;
    margin-top: -6px;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #862121;
  }

  .contact__main {
    max-width: 900px;
    position: relative;
  }

  .contact__main h4 {
    color: #FFFFFF;
  }

  .contact__infos {
    font-size: 1.5rem;
  }

  .contact__form {
    padding-right: 40px;
  }

  .contact__form input[type="email"],
  .contact__form input[type="number"],
  .contact__form input[type="text"],
  .contact__form input[type="tel"],
  .contact__form input[type="url"],
  .contact__form textarea {
    background-color: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: .9rem;
    color: rgba(255, 255, 255, 0.75);
  }

  .contact__form input[type="email"]:focus,
  .contact__form input[type="number"]:focus,
  .contact__form input[type="text"]:focus,
  .contact__form input[type="tel"]:focus,
  .contact__form input[type="url"]:focus,
  .contact__form textarea:focus {
    color: white;
    border-bottom: 1px solid white;
  }

  .contact__form button {
    margin-top: 4.2rem;
    background-color: #862121;
    border-color: #862121;
  }

  .message-warning,
  .message-success {
    display: none;
    background: #0D0A0B;
    font-size: 1.5rem;
    line-height: 2;
    padding: 3rem;
    margin-bottom: 3.6rem;
    width: 100%;
  }

  .message-warning {
    color: #ff6163;
  }

  .message-success {
    color: #008C2C;
  }

  .message-warning i,
  .message-success i {
    margin-right: 10px;
    font-size: 1.2rem;
  }

  /* form loader */

  .submit-loader {
    display: none;
    position: relative;
    left: 0;
    top: 1.8rem;
    width: 100%;
    text-align: center;
    margin-bottom: 4.2rem;
  }

  .submit-loader .text-loader {
    display: none;
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.4rem;
    color: #FFFFFF;
    letter-spacing: .2rem;
    text-transform: uppercase;
  }

  .oldie .submit-loader .s-loader {
    display: none;
  }

  .oldie .submit-loader .text-loader {
    display: block;
  }

  /* --------------------------------------------------------------- 
 * loader animation - (_site-layout.scss)
 * --------------------------------------------------------------- */

  .s-loader {
    margin: 1.2rem auto 3rem;
    width: 70px;
    text-align: center;
    -webkit-transform: translateX(0.45rem);
    -ms-transform: translateX(0.45rem);
    transform: translateX(0.45rem);
  }

  .s-loader>div {
    width: 9px;
    height: 9px;
    background-color: #FFFFFF;
    border-radius: 100%;
    display: inline-block;
    margin-right: .9rem;
    -webkit-animation: bouncedelay 1.4s infinite ease-in-out both;
    animation: bouncedelay 1.4s infinite ease-in-out both;
  }

  .s-loader .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .s-loader .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes bouncedelay {

    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      -ms-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes bouncedelay {

    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      -ms-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * contact
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 800px) {
    .contact__form {
      padding-right: 15px;
    }

    .contact__infos {
      padding-top: 3rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .contact__form {
      padding-right: 10px;
    }
  }

  @media only screen and (max-width: 400px) {
    .contact__form {
      padding-right: 0;
    }
  }

  /* ===================================================================
 * # footer - (_site-layout.scss)
 *
 * ------------------------------------------------------------------- */

  footer {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 14px;
    padding: 6.6rem 0 4.2rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.2);
  }

  footer a,
  footer a:visited {
    color: #862121;
  }

  footer a:hover,
  footer a:focus {
    color: #FFFFFF;
  }

  .footer-logo {
    display: inline-block;
  }

  .footer-site-logo {
    display: block;
    width: 130px;
  }

  .footer-social {
    list-style: none;
    margin-top: 3rem;
    margin-left: 0;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.3rem;
    text-transform: uppercase;
    letter-spacing: .3rem;
  }

  .footer-social:after {
    content: "";
    display: table;
    clear: both;
  }

  .footer-social li {
    display: inline-block;
    padding-left: 0;
    margin-right: .9rem;
    line-height: 3.9rem;
    vertical-align: middle;
  }

  .footer-social li::after {
    content: "|";
    color: rgba(255, 255, 255, 0.15);
    padding-left: .9rem;
  }

  .footer-social li i {
    font-size: 1.7rem;
    line-height: 3rem;
    vertical-align: middle;
  }

  .footer-social li span {
    margin-left: .6rem;
  }

  .footer-social li a {
    color: #FFFFFF;
  }

  .footer-social li:last-child {
    margin-right: 0;
  }

  .footer-social li:last-child::after {
    display: none;
  }

  .footer-bottom {
    margin-top: 7.2rem;
    text-align: center;
  }

  .footer-bottom .copyright span {
    display: inline-block;
  }

  .footer-bottom .copyright span::after {
    content: "|";
    display: inline-block;
    padding: 0 1rem 0 1.2rem;
    color: rgba(255, 255, 255, 0.1);
  }

  .footer-bottom .copyright span:last-child::after {
    display: none;
  }

  /* ------------------------------------------------------------------- 
 * ## go to top
 * ------------------------------------------------------------------- */

  .go-top {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 600;
    display: none;
  }

  .go-top a,
  .go-top a:visited {
    text-decoration: none;
    border: 0 none;
    display: block;
    height: 60px;
    width: 60px;
    line-height: 60px;
    text-align: center;
    background: black;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    text-transform: uppercase;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  .go-top a i,
  .go-top a:visited i {
    font-size: 12px;
    line-height: inherit;
  }

  .go-top a:hover,
  .go-top a:focus {
    color: #FFFFFF;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * footer 
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 600px) {
    .footer-social li {
      margin-right: 1.8rem;
    }

    .footer-social li span,
    .footer-social li::after {
      display: none;
    }

    .footer-social li i {
      font-size: 2.4rem;
    }

    .footer-bottom {
      padding-bottom: .6rem;
    }

    .footer-bottom .copyright span {
      display: block;
    }

    .footer-bottom .copyright span::after {
      display: none;
    }
  }

  @media only screen and (max-width: 400px) {
    .footer-site-logo {
      width: 100px;
    }

    .footer-social li {
      margin-right: 1.2rem;
    }

    .footer-social li i {
      font-size: 2.2rem;
    }
  }

  /* ===================================================================
 * # blog styles - (_blog.scss)
 *
 * ------------------------------------------------------------------- */

  article.blog-single {
    background-color: #FFFFFF;
  }

  article.blog-single .blog-content {
    padding-top: 7.2rem;
    padding-bottom: 12rem;
  }

  /* -------------------------------------------------------------------
 * ## blog page header
 * ------------------------------------------------------------------- */

  .page-header {
    background-color: #0D0A0B;
    background-repeat: no-repeat;
    background-position: center, center;
    padding-top: 20.4rem;
    padding-bottom: 7.2rem;
    position: relative;
    color: rgba(255, 255, 255, 0.5);
    min-height: 50.4rem;
  }

  .page-header--single {
    padding-top: 22.8rem;
    padding-bottom: 7.2rem;
    text-align: center;
  }

  .page-header::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .75;
    background-color: #0D0A0B;
  }

  .page-header::after {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: -moz-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.65) 100%);
    /* FF3.6-15 */
    background: -webkit-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.65) 100%);
    /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.65) 100%);
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#a6000000', GradientType=0);
    /* IE6-9 */
  }

  .page-header__content {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 2rem;
    line-height: 1.8;
    position: relative;
    max-width: 900px;
    z-index: 2;
  }

  .page-header__content p {
    padding-right: 3rem;
  }

  .page-header__info {
    margin-bottom: 1.2rem;
  }

  .page-header__info .div:last-child {
    margin-right: 0;
  }

  .page-header__cat,
  .page-header__date {
    display: inline-block;
    margin-right: 2rem;
    margin-bottom: .3rem;
  }

  .page-header__cat {
    font-size: 1.4rem;
    line-height: 1.5;
    text-transform: uppercase;
    letter-spacing: .16rem;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
  }

  .page-header__cat a {
    color: rgba(255, 255, 255, 0.8);
  }

  .page-header__cat a:hover,
  .page-header__cat a:focus,
  .page-header__cat a:active {
    color: white;
  }

  .page-header__cat a::after {
    content: ", ";
  }

  .page-header__cat a:last-child::after {
    display: none;
  }

  .page-header__date {
    font-display: swap;
    font-family: "montserrat-light", sans-serif;
    font-size: 1.5rem;
    color: rgba(255, 255, 255, 0.4);
  }

  .page-header__date a {
    color: rgba(255, 255, 255, 0.4);
  }

  .page-header__date a:hover,
  .page-header__date a:focus,
  .page-header__date a:active {
    color: white;
  }

  .page-header__title {
    color: #FFFFFF;
    position: relative;
    font-display: swap;
    font-family: "librebaskerville-bold", serif;
    font-size: 6.6rem;
    line-height: 1.227;
    margin-top: 0;
    margin-bottom: 3.6rem;
  }

  .page-header__title a {
    color: #FFFFFF;
  }

  .page-header__meta {
    list-style: none;
    margin-left: 0;
    padding-top: 2.4rem;
    font-size: 1.6rem;
    position: relative;
  }

  .page-header__meta::before {
    display: block;
    content: "";
    height: 1px;
    width: 100px;
    background-color: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -50px;
  }

  .page-header__meta li {
    display: inline-block;
    padding-left: 0;
    margin-right: 2rem;
  }

  .page-header__meta li::last-child {
    margin-right: 0;
  }

  .page-header__meta span,
  .page-header__meta a {
    color: #FFFFFF;
  }

  .page-header__btn {
    border-color: #FFFFFF !important;
    color: #FFFFFF;
    letter-spacing: .25rem;
  }

  .page-header__btn:hover,
  .page-header__btn:focus {
    background: #FFFFFF !important;
    color: #000000;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * blog page header
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .page-header__content {
      max-width: 800px;
      font-size: 1.7rem;
    }

    .page-header__cat {
      font-size: 1.3rem;
    }

    .page-header__title {
      font-size: 6rem;
    }
  }

  @media only screen and (max-width: 900px) {
    .page-header__content {
      max-width: 700px;
    }
  }

  @media only screen and (max-width: 800px) {
    .page-header--single {
      padding-top: 18rem;
    }

    .page-header__title {
      font-size: 5.4rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .page-header {
      padding-top: 18rem;
    }

    .page-header__content p {
      padding-right: 0;
    }

    .page-header__title {
      font-size: 4.8rem;
    }
  }

  @media only screen and (max-width: 500px) {
    .page-header__title {
      font-size: 4.2rem;
    }
  }

  @media only screen and (max-width: 400px) {
    .page-header__content {
      font-size: 1.6rem;
      line-height: 1.875;
    }

    .page-header__title {
      font-size: 3.8rem;
    }
  }

  /* -------------------------------------------------------------------
 * ## blog content - _blog.scss
 * ------------------------------------------------------------------- */

  .blog-content-wrap {
    background-color: #FFFFFF;
    padding-top: 4.2rem;
    padding-bottom: 12rem;
  }

  .blog-content {
    max-width: 1000px;
  }

  .blog-content__main {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .blog-content__main img {
    max-width: 1000px;
    margin: 3rem 0 3rem -6rem;
  }

  /* post tags
 * ------------------------------------------------- */

  .blog-content__tags {
    margin-top: 6rem;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
  }

  .blog-content__tags span {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    color: #0D0A0B;
    position: relative;
    padding-right: 55px;
    margin-right: 1.5rem;
    margin-top: 1.2rem;
  }

  .blog-content__tags span::after {
    display: inline-block;
    content: "";
    height: 1px;
    width: 40px;
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 50%;
    right: 0;
  }

  .blog-content__tags .blog-content__tag-list {
    display: inline-block;
    padding-right: 0;
    margin-right: 0;
  }

  .blog-content__tags .blog-content__tag-list::after {
    display: none;
  }

  .blog-content__tags .blog-content__tag-list a {
    display: inline-block;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.3rem;
    line-height: inherit;
    color: #797979;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    margin-right: 6px;
    margin-bottom: 6px;
    padding: 0 10px;
  }

  .blog-content__tags .blog-content__tag-list a:hover,
  .blog-content__tags .blog-content__tag-list a:focus {
    background-color: #0D0A0B;
    border-color: #0D0A0B;
    color: #FFFFFF;
  }

  .blog-content__tags .blog-content__tag-list a:last-child {
    margin-right: 0;
  }

  /* blog single page navigation
 * ------------------------------------------------- */

  .blog-content__pagenav {
    margin-top: 7.8rem;
    padding-top: 1.8rem;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .blog-content__nav {
    padding-right: 220px;
  }

  .blog-content__nav:after {
    content: "";
    display: table;
    clear: both;
  }

  .blog-content__nav span {
    display: block;
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.6rem;
    color: #797979;
    margin-bottom: 1.2rem;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  .blog-content__nav a {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 2.2rem;
    line-height: 1.5;
    color: #0D0A0B;
  }

  .blog-content__nav a:hover span,
  .blog-content__nav a:focus span {
    color: #0D0A0B;
  }

  .blog-content__prev,
  .blog-content__next {
    width: 50%;
    float: left;
    padding-right: 2rem;
  }

  .blog-content__all {
    text-align: right;
    width: 210px;
    position: absolute;
    top: 2.1rem;
    right: 0;
  }

  .blog-content__all .im {
    font-size: 1.4rem;
    line-height: 1;
    margin-right: 8px;
    position: relative;
    top: 2px;
  }

  /* blog entries navigation
 * ------------------------------------------------- */

  .blog-entries-nav {
    text-align: center;
    max-width: 600px;
    padding-top: 3.6rem;
  }

  .blog-entries-nav .btn {
    margin-right: 3rem;
    min-width: 150px;
  }

  .blog-entries-nav .btn:last-child {
    margin-right: 0;
  }

  .blog-entries-nav .im {
    font-size: 1.3rem;
    line-height: 1;
    position: relative;
    top: 2px;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * blog content
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 1200px) {
    .blog-content {
      max-width: 900px;
    }

    .blog-content__main {
      padding-left: 5rem;
      padding-right: 5rem;
    }

    .blog-content__main img {
      max-width: 900px;
      margin: 3rem 0 3rem -5rem;
    }
  }

  @media only screen and (max-width: 1000px) {
    .blog-content {
      max-width: 800px;
    }

    .blog-content__main {
      padding-left: 4rem;
      padding-right: 4rem;
    }

    .blog-content__main img {
      max-width: 800px;
      margin: 3rem 0 3rem -4rem;
    }

    .blog-content__prev,
    .blog-content__next {
      width: 100%;
      float: none;
      padding: 0;
      text-align: left;
      margin-bottom: 1.8rem;
    }
  }

  @media only screen and (max-width: 900px) {
    .blog-content__main {
      padding-left: 15px;
      padding-right: 15px;
    }

    .blog-content__main img {
      max-width: 100%;
      margin: 3rem 0 3rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .blog-content__nav {
      padding-right: 0;
    }

    .blog-content__all {
      position: static;
      text-align: left;
      width: auto;
      margin-top: 1.8rem;
    }
  }

  @media only screen and (max-width: 600px) {

    .blog-content__prev,
    .blog-content__next,
    .blog-content__all {
      text-align: center;
    }

    .blog-content__main {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  @media only screen and (max-width: 500px) {
    .blog-entries-nav .btn {
      margin-right: 0;
      min-width: none;
      width: 100%;
    }
  }

  @media only screen and (max-width: 400px) {
    .blog-content__main {
      padding-left: 0;
      padding-right: 0;
    }

    .blog-content__all .btn {
      width: 100%;
    }
  }

  /* -------------------------------------------------------------------
 * ## comments - _blog.scss
 * ------------------------------------------------------------------- */

  .comments-wrap {
    background-color: #f0f0f0;
    padding: 8.4rem 0 9rem;
  }

  /* comments
 * -------------------------------------------------- */

  #comments {
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
    max-width: 940px;
  }

  #comments h3 {
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  #comments ol,
  #comments ul {
    list-style: none;
  }

  .commentlist {
    margin: 3rem 0 5.4rem;
    padding: 0;
  }

  .commentlist>.comment {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 1.8rem 0;
    padding-left: 14%;
  }

  .comment__avatar {
    position: absolute;
    left: 0;
    display: block;
    height: 6rem;
    width: 6rem;
  }

  .comment__avatar img {
    margin-top: 0.6rem;
    height: 6rem;
    width: 6rem;
    border-radius: 100%;
  }

  .comment__info cite {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.8rem;
    font-style: normal;
    color: #0D0A0B;
  }

  .comment__meta {
    font-weight: 400;
    font-display: swap;
    font-family: montserrat, sans-serif;
    font-size: 1.45rem;
    line-height: 3rem;
    font-style: normal;
    display: block;
    color: rgba(0, 0, 0, 0.7);
  }

  .comment__meta .reply {
    font-weight: 700;
    font-display: swap;
    font-family: montserrat, sans-serif;
  }

  .comment__meta .sep {
    margin: 0 5px;
  }

  .comment__text {
    clear: both;
    margin: 1.8rem 0 0 0;
    padding: 0;
  }

  .comment ul.children {
    margin: 0;
    padding: 1.8rem 0 0 0;
  }

  .comment ul.children li {
    padding-left: 5%;
    padding-top: 1.8rem;
  }

  /* comments form
 * ---------------------------- */

  #comments .respond {
    padding-top: 4.2rem;
  }

  #comments form {
    padding-top: 3rem;
  }

  #comments form .form-field {
    margin-bottom: 3.9rem;
  }

  /* ------------------------------------------------------------------- 
 * responsive:
 * comments
 * ------------------------------------------------------------------- */

  @media only screen and (max-width: 800px) {
    #comments form button {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    #comments h3 {
      text-align: center;
    }

    .commentlist>.comment {
      padding-left: 0;
    }

    .commentlist .comment__avatar {
      display: none;
    }
  }

  a#statuslogo {
    font-display: swap;
    font-family: fontello;
    font-weight: 700;
    font-size: 25px;
    line-height: 1em;
    position: absolute;
    width: 44px;
    height: 44px;
    z-index: 2;
    top: 5px;
    transition: color 2s;
    left: -10px;
    background: url(/images/circle.svg) no-repeat;
  }

  a#statuslogo {
    color: #c4d732;
    color: white;
  }

  a#statuslogo.error {
    color: white
  }

  a#statuslogo.warn {
    color: orange
  }

  a#statuslogo:before {
    content: '\e802';
    position: absolute;
    left: 9px;
    top: 10px;
  }

  body,
  #mainBody,
  #one,
  #homeheader,
  #home,
  #confirmOverlay,
  #homeimage,
  #app,
  #page {}

  html {
    font-size: 10px;
  }

  @media only screen and (max-width: 400px) {
    html {
      font-size: 9.375px;
    }
  }

  html,
  body {
    height: 100%;
  }

  body {
    font-display: swap;
    font-size: 1.6rem;
    line-height: 1.875;
    color: #5f5f5f;
    margin: 0;
    padding: 0;
  }

  body .v--modal {
    line-height: initial;
  }

  body.white {}

  body.dark {}

  body {
    overflow-x: hidden;
    width: 100%;
    height: 100%;
  }

  #mainBody,
  #home {
    top: 0;
    position: relative;
    min-width: 100vw !important;
    min-height: 100vh !important;
    background-color: inherit;
    overflow-x: hidden;
  }

  #one {
    box-shadow: 0px -5px 15px 0px rgba(0, 0, 0, 0.6);
    min-height: 100%;
    width: 100%;
    height: 100%;
    position: relative;
    left: 0px;
    /*transform: translate3d(192px,0,0); transform: translate3d(0,0,0);*/
    transition: left 0.3s ease;
  }

  #topleftcorner {
    position: fixed;
    top: 5px;
    left: 5px;
    z-index: 1;
    width: 20px;
    height: 20px;
    z-index: 501;
  }

  #topleftcorner::before {
    content: url(/images/corner-top-left.svg);
    position: absolute;
    opacity: 0.1;
    cursor: pointer;
    transition: opacity 0.6s ease;
  }

  #topleftcorner:hover:before {
    opacity: 1;
  }

  .menu #topleftcorner {
    opacity: 0;
    display: none;
  }

  #one>section,
  #one>header.sticky {
    box-shadow: 0px -5px 15px 0px rgba(0, 0, 0, 0.6);
  }

  body.dark #one {
    box-shadow: none;
  }

  .menu #one {
    left: 162px;
  }

  .menu #zoomFullScreen,
  body.synchrony.menu #sync-nav #toggleMenu {
    opacity: 1;
    display: block
  }

  .header-logo {
    font-family: "montserrat-bold", sans-serif;
    font-size: 14px;
    color: #eee;
    line-height: 72px;
    text-transform: uppercase;
    width: 400px;
    letter-spacing: .3rem;
    top: 0;
    position: absolute
  }

  .username {
    position: absolute;
    left: 40px;
    color: white;
  }

  .sticky .header-logo {
    top: 0;
  }

  .sticky #statuslogo {
    top: 13px;
  }

  #zoomFullScreen {
    position: fixed;
    left: 8px;
    bottom: 35px;
    font-family: Glyphicons;
    display: block;
    width: 24px;
    height: 2px;
    z-index: 2;
    margin: 3px 4px 0 12px;
    opacity: 0;
  }

  #zoomFullScreen:hover {
    cursor: pointer;
    color: whitesmoke;
    opacity: 1;
    transition: opacity 0.3s
  }

  body #mainBody #homeimage video {
    height: 100% !important;
    width: 177.77777778vh !important;
    min-width: 100% !important;
    min-height: 56.25vw;
    object-fit: cover !important;
    right: unset !important;
    top: unset !important;
    max-height: unset !important;
  }

  body #mainBody #homeimage {
    background-color: #232323;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    width: 100%;
    height: 100vh;
    webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    /*
    background-image:url(/img/genome.jpg);
    */
    filter: brightness(0.5);
  }

  #confirmOverlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    /* 
  background: url("ie.png"); 
  background: -moz-linear-gradient(rgba(11, 11, 11, 0.1), rgba(11, 11, 11, 0.6)) repeat-x rgba(11, 11, 11, 0.2); 
  background: -webkit-gradient(linear, 0% 0, 0% 100%, from(rgba(11, 11, 11, 0.1)), to(rgba(11, 11, 11, 0.6))) repeat-x rgba(11, 11, 11, 0.2); 
*/
    z-index: 100000;
  }

  #confirmBox {
    text-align: center;
    /*background: url("/images/body_bg.jpg") repeat-x left bottom #e5e5e5;*/
    background: #e5e5e5;
    width: 460px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    /*  left: 50%; */
    top: 25%;
    /*  margin: -130px 0 0 -230px; */
    border: 1px solid rgba(33, 33, 33, 0.3);
    border-radius: 5px;
    -moz-box-shadow: 0 0 2px rgba(255, 255, 255, 0.6) inset;
    -webkit-box-shadow: 0 0 2px rgba(255, 255, 255, 0.6) inset;
    box-shadow: 0 0 2px rgba(255, 255, 255, 0.6) inset;
  }

  #confirmBox h1,
  #confirmBox p {
    font: 20px/1 'Cuprum', 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;
    padding: 15px 5px 0;
    text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.6);
    color: #666;
  }

  #confirmBox h1 {
    margin-top: 0;
    letter-spacing: .3px;
    color: #888;
  }

  #confirmBox p {
    background: 0;
    font-size: 16px;
    line-height: 1.4;
    padding-top: 0;
  }

  #confirmBox.info {
    position: fixed;
    width: unset;
    padding: 0px 28px;
    border: 11px solid rgba(115, 115, 115, 0.6);
  }

  #confirmBox.info p {
    font-size: 20px;
    margin-top: -10px;
    margin-bottom: 15px;
  }

  #confirmButtons {
    padding: 5px 0 25px;
    text-align: center;
  }

  #confirmBox table {
    font-family: "Open Sans", sans-serif;
  }

  #confirmBox .button {
    display: inline-block;
    color: white !important;
    position: relative;
    height: 33px;
    font: 17px/33px 'Cuprum', 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;
    margin-right: 15px;
    padding: 0 35px 0 40px;
    text-decoration: none;
    border: 0;
  }

  #confirmBox .button:last-child {
    margin-right: 0;
  }

  #confirmBox .button span {
    position: absolute;
    top: 0;
    right: -5px;
    height: 33px;
  }

  #confirmBox .blue {
    background: #487B20;
    background-position: left top;
    text-shadow: 1px 1px 0 #5889a2;
  }

  #confirmBox .blue span {
    background-position: -195px 0;
  }

  #confirmBox .blue:hover {
    background: brown;
    background-position: left bottom;
  }

  #confirmBox .blue:hover span {
    background: brown;
    background-position: -195px bottom;
  }

  #confirmBox .gray {
    background-position: -200px top;
    background: gray;
    text-shadow: 1px 1px 0 #707070;
  }

  #confirmBox .gray span {
    background-position: -395px 0;
  }

  #confirmBox .gray:hover {
    background: goldenrod;
    background-position: -200px bottom;
  }

  #confirmBox .gray:hover span {
    background-position: -395px bottom;
  }

  #confirmBox #dialogInput {
    color: rgb(0, 96, 128);
    font-family: Cuprum, 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;
    font-size: 18px;
    box-sizing: border-box;
    resize: none;
    margin-bottom: 20px;
  }

  #confirmBox #textInput {
    box-sizing: border-box;
    padding: 0em 1em;
    text-align: center;
    color: rgb(0, 128, 52);
    font-family: Cuprum, 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;
    font-size: 12px;
    background-color: inherit;
  }

  #confirmBox input:focus {
    border-color: #62bd83;
    box-shadow: 0 0 0 1px #62bd83;
  }

  .dialogCheck input[type="checkbox"]+label {
    position: absolute;
    top: 5px;
    right: 0px;
    font-size: 10px;
  }

  body.synchrony #mainBody #sync-nav {
    z-index: 500;
    width: 52px;
    background: transparent;
    transition: opacity 0.3s ease;
    position: fixed;
  }

  body.synchrony #mainBody #sync-nav.article {
    background: transparent;
    opacity: 0;
  }

  body.synchrony.menu #mainBody #sync-nav.article {
    opacity: 1;
  }

  body.synchrony.menu #mainBody #sync-nav:hover {
    opacity: 1;
  }

  body.synchrony #sync-nav #toggleMenu {
    position: relative;
    margin-left: 16px;
    font-size: 20px;
    margin-top: -14px;
    font-family: Glyphicons;
    display: none
  }

  body.synchrony #sync-nav #toggleMenu:hover {
    opacity: 1;
    cursor: pointer;
    color: silver
  }

  ;

  body.dark:not(.menu) #sync-nav.article #toggleTheme,
  body.dark:not(.menu) #sync-nav.article #toggleMenu {
    color: transparent;
    text-shadow: none;
  }

  body.synchrony.dark:not(.menu) #sync-nav.article .container:hover #toggleTheme,
  body.synchrony.dark:not(.menu) #sync-nav.article .container:hover #toggleMenu {
    color: rgba(253, 253, 253, 0.6);
  }

  body.synchrony #sync-nav #sectionIcons #toggleTransition {
    font-size: 18px;
    position: relative;
    font-family: Glyphicons;
    transition: color 0.3s ease;
    display: none
  }

  body.dark:not(.menu) #sync-nav.article #toggleTransition,
  body.dark:not(.menu) #sync-nav.article #toggleMenu {
    color: transparent;
    text-shadow: none;
  }

  body.synchrony.dark:not(.menu) #sync-nav.article .container:hover #toggleTransition {
    color: rgba(253, 253, 253, 0.6);
  }

  .container#sync-nav-active {
    padding: 0px 1px 0px 0px;
  }

  .container#sync-nav-state-max {
    left: 230px;
    position: relative;
    transition: left 0.3s ease;
  }

  #sync-nav {
    position: fixed;
    overflow: hidden;
    border-right-width: 0px;
    border-right-style: solid;
    border-right-color: rgba(92, 92, 92, 0.498039);
    top: 0px;
    left: 0px;
    width: 170px;
    height: 100%;
    z-index: 10005;
    transition: opacity 0.2s ease, width 0.3s ease, background-color 0.3s ease;
    background: #242424;
  }

  #sync-nav.empty>* {
    opacity: 0.5;
  }

  #sync-nav>* {
    transition: opacity 0.2s ease;
  }

  .white #sync-nav {
    border-right-style: none;
  }

  #sync-nav ul {
    overflow-y: hidden;
    list-style-type: none;
    padding: 20px 0px 0px;
    margin: 0px;
  }

  #sync-nav>a,
  #sectionIcons a {
    display: table;
    padding: 10px 0px;
    margin-left: 17px;
    position: relative;
  }

  #sync-nav a:hover {
    text-decoration: none;
  }

  #sync-nav #sync-nav-min {
    overflow-y: hidden;
    width: 50px;
    text-align: left;
    display: block;
    padding: 8px 3px 3px 6px;
  }

  #sync-nav #sync-nav-min:hover {
    text-decoration: none;
  }

  #sync-nav #sync-nav-max {
    position: absolute;
    top: 0px;
    left: 25px;
    width: 225px;
    overflow-y: hidden;
    padding: 8px 10px 8px 0px;
  }

  #sync-nav .icon-bar {
    position: relative;
    font-family: Glyphicons;
  }

  #sync-nav #sync-nav-toggle {
    display: block;
    margin: 8px 0px;
  }

  #sync-nav ul ul a {
    padding: 8px 3px 8px 25px;
  }

  #sync-nav a:active {
    outline: none;
  }

  #sync-nav #sync-nav-max {
    display: none;
  }

  #sync-nav li {
    display: none;
  }

  #sync-nav li#sync-nav-shortcut {
    display: inline-block;
    width: 100%;
  }

  #sync-nav-state-max li {
    display: list-item;
    width: 100%;
  }

  #sync-nav-state-max li #sync-nav-min,
  #sync-nav-state-max li #sync-nav-max {
    display: inline-block;
  }

  #sync-nav-state-max li #sync-nav-max {
    width: 260px;
  }

  #sync-nav-state-max#sync-nav {
    width: 290px;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: rgba(128, 128, 128, 0.498039);
    transition: width 0.3s ease, background-color 0.3s ease;
    background: rgb(51, 51, 51);
  }

  body.dark #sync-nav a {
    color: darkgrey;
  }

  body.dark #sync-nav a.active {
    background-color: rgb(43, 43, 43);
  }

  body.dark #sync-nav #sync-nav-toggle:hover {
    background-color: inherit;
  }

  body.light #sync-nav {
    background: rgb(236, 236, 236);
  }

  body.white #sync-nav {
    background: rgb(236, 236, 236);
  }

  body.white #sync-nav-state-max {
    background: rgb(236, 236, 236);
  }

  body.white #sync-nav a {
    color: rgb(168, 168, 168);
  }

  body.white #sync-nav a.active {
    background-color: white;
  }

  body.white #sync-nav #sync-nav-toggle:hover {
    background-color: inherit;
  }

  body.dark:not(.menu) #sync-nav.article {
    border: none;
    box-shadow: none;
    background: transparent;
  }

  body.dark #sync-nav.article #navpanel {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: transparent;
  }

  body.dark.menu #sync-nav.article #navpanel {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: rgb(34, 34, 34);
  }

  body:not(.menu) #sync-nav.article a {
    color: rgb(128, 128, 128);
    text-shadow: rgb(214, 213, 213) 1px 1px 1px;
  }

  body.synchrony #sync-nav a,
  body.synchrony #sync-nav {
    color: rgb(84, 84, 84);
    padding-top: 10px;
    z-index: 0
  }

  body.white #sync-nav.article a,
  body.white #sync-nav a,
  body.white #sync-nav {
    color: rgb(206, 206, 206);
  }

  body.synchrony[data-section="decks"] #sync-nav .autoplay {
    display: none
  }

  #sync-nav .autoplay {
    position: absolute;
    bottom: 0px;
  }

  #sync-nav .autoplay:hover {
    cursor: pointer;
    color: whitesmoke;
  }

  #sync-nav .autoplay>.play {
    font-family: Glyphicons;
    position: absolute;
    bottom: 56px;
    left: 12px;
    font-size: 26px;
  }

  #sync-nav .autoplay>.play::before {
    content: "î…´";
  }

  #sync-nav .autoplay>.stop {
    display: none;
    font-family: Glyphicons;
    position: absolute;
    bottom: 56px;
    left: 12px;
    font-size: 26px;
  }

  #sync-nav .autoplay>.stop::before {
    content: "î…¶";
  }

  #sync-nav#sync-nav .logo_hidden {
    display: none;
  }

  #sync-nav#sync-nav-state-max .logo_hidden {
    display: inline;
    font-size: 200%;
    float: right;
    margin-right: 20px;
    margin-top: 10px;
    position: relative;
    text-shadow: rgb(149, 149, 149) 3px 3px 6px;
    color: rgb(80, 80, 80);
  }

  #sync-nav.article #widgetFilters {
    border: none;
  }

  #sync-nav.display .filter #widgetFilters div.widgetArray {}

  #sync-nav.display .filter #widgetFilters div.block {
    display: block;
    width: 120px;
    height: 120px;
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: rgba(128, 128, 128, 0.309804);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: rgba(128, 128, 128, 0.309804);
    padding-left: 9px;
    padding-top: 5px;
    color: gray;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    transition: all 0.3s ease;
  }

  #sync-nav.display .filter #widgetFilters div.block img {
    position: relative;
    margin-left: -8px;
    margin-top: -28px;
    opacity: 0.3;
    z-index: -1;
  }

  #sync-nav.display .filter #widgetFilters div.widgetArray>div.filtered {
    color: white;
    text-shadow: rgb(45, 45, 45) 1px 1px 6px;
  }

  #sync-nav .filter:hover {
    cursor: pointer;
    color: whitesmoke;
  }

  #sync-nav .filter>.toggle {
    font-family: Glyphicons;
    position: absolute;
    bottom: 100px;
    left: 17px;
    font-size: 16px;
  }

  #sync-nav.article .filter>.toggle {
    display: none;
  }

  #sync-nav .filter>.toggle::before {
    content: "î„·";
  }

  #sync-nav .filter .labels {
    display: none;
  }

  #sync-nav.display {
    width: 194px;
    box-shadow: none;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: rgba(92, 92, 92, 0.2);
  }

  #sync-nav.display .filter .labels {
    display: block;
  }

  #sync-nav .filter .labels span.save {
    font-family: Glyphicons;
    position: absolute;
    left: 15px;
    bottom: 60px;
    font-size: 20px;
    color: green;
    cursor: pointer;
  }

  #sync-nav .filter .labels span.cancel {
    font-family: Glyphicons;
    position: absolute;
    left: 15px;
    bottom: 100px;
    font-size: 20px;
    color: goldenrod;
    cursor: pointer;
  }

  #sync-nav .filter .labels span.all {
    font-family: Glyphicons;
    position: absolute;
    left: 17px;
    bottom: 20px;
    color: gray;
    font-size: 16px;
    cursor: pointer;
  }

  #sync-nav .filter .labels span.none {
    display: none;
    font-family: Glyphicons;
    position: absolute;
    left: 17px;
    bottom: 20px;
    font-size: 16px;
    color: gray;
    cursor: pointer;
  }

  #sync-nav .filter .labels.toggled span.none {
    display: block;
  }

  #sync-nav .filter .labels.toggled span.all {
    display: none;
  }

  #sync-nav.display .filter #widgetFilters div.block.filtered img {
    opacity: 1;
  }

  #async-nav.display .filter #widgetFilters div.block:hover,
  #async-nav.display .filter #widgetFilters div.block:hover img {
    color: white;
    opacity: 1;
    text-shadow: rgb(45, 45, 45) 1px 1px 6px;
  }

  #async-nav.display .filter #widgetFilters div.block:hover::after {
    float: right;
    content: "îˆ‡";
    margin-top: -80px;
    margin-right: 36px;
    font-size: 48px;
    font-family: Glyphicons;
    color: green;
    text-shadow: white 2px 0px 50px;
  }

  #sync-nav.display .filter #widgetFilters div.block::after {
    float: right;
    content: "";
    margin-top: -80px;
    margin-right: 36px;
    font-size: 48px;
    font-family: Glyphicons;
    color: whitesmoke;
    transition: all 0.6s ease;
  }

  #async-nav.display .filter #widgetFilters div.block.filtered:hover::after {
    float: right;
    content: "îˆˆ";
    margin-top: -80px;
    margin-right: 36px;
    font-size: 48px;
    font-family: Glyphicons;
    color: goldenrod;
    text-shadow: white 2px 0px 50px;
  }

  #sync-nav.display .filter #widgetFilters div.block.filtered::after {
    float: right;
    content: "îˆ‡";
    margin-top: -80px;
    margin-right: 36px;
    font-size: 48px;
    font-family: Glyphicons;
    color: whitesmoke;
    transition: all 0.6s ease;
  }

  #navpanel li {
    display: block;
  }

  body.dark #sync-nav.article #navpanel {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: transparent;
  }

  body.dark.menu #sync-nav.article #navpanel {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: rgb(34, 34, 34);
  }

  #navpanel {
    position: fixed;
    top: 0px;
    list-style: none;
    left: 52px;
    margin-left: 0;
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: rgb(34, 34, 34);
    width: 80px;
    padding-right: 10px;
    padding-top: 7px;
    height: 100%;
    text-align: right;
    font-size: 18px;
    line-height: 2em;
    color: rgb(79, 79, 79);
    font-weight: 700;
    font-family: Lato, 'Open Sans', sans-serif;
    z-index: 0;
    transition: border 0.3s ease;
    box-sizing: content-box;
    margin: 0 0 2em 0;
    overflow-x: hidden;
    padding-left: 1em
  }

  body.dark #navpanel {
    border-left-color: rgb(10, 10, 10);
  }

  body.synchrony #navpanel li {
    color: whitesmoke;
  }

  body #navpanel span.nav-max {
    padding-right: 9px;
  }

  body #navpanel span.nav-max:hover,
  body #navpanel li.highlit span.nav-max {
    cursor: pointer;
    padding: 3px 8px 6px;
    border-radius: 15px;
    color: whitesmoke;
    border: 1px solid rgba(173, 173, 173, 0.6);
    background: rgb(63, 95, 0);
  }

  body #navpanel li.highlit span.nav-max {
    margin-top: 2px;
    margin-bottom: 2px;
    background: #4d4d4d;
    color: whitesmoke;
  }

  body.white #navpanel li.highlit span.nav-max {
    margin-top: 2px;
    margin-bottom: 2px;
    background: rgba(0, 0, 0, 0.7);
    color: whitesmoke;
  }

  body.white #navpanel span.nav-max:hover,
  body.white #navpanel li.highlit span.nav-max:hover {
    background: brown;
  }

  body.synchrony #navpanel li.highlit {
    margin-top: 4px;
    margin-bottom: 6px;
  }

  body.white #navpanel li span {
    color: rgb(33, 33, 33);
  }

  body.white #navpanel {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: silver;
  }

  #navpanel.max {
    width: 200px;
    padding-right: 40px;
  }

  body .text-center {
    text-align: center;
  }

  body #app {
    text-align: unset;
    margin-top: unset;
  }

  .ss-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    float: left;
  }

  .ss-content {
    height: 100%;
    width: 100%;
    padding: 0 0 0 0;
    position: absolute;
    overflow: auto;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  body .ss-content {
    width: calc(100% + 18px);
  }

  body.isMobile .container {
    max-width: 100vw !important;
  }

  body.isMobile .container .row {
    margin-left: 0;
    margin-right: 0;
  }

  body.isMobile .info.info-hover .icon.icon-calc {
    padding-left: 0;
  }

  body.isMobile .card.card-background-product.card-raised.card-background {
    width: calc(100vw - 50px) !important;
    height: calc(100vw - 50px) !important;
    margin-left: -30px !important;
  }

  html {
    scroll-behavior: smooth;
  }

  .header-nav-wrap {
    top: 0px;
    font-family: sans-serif !important;
  }

  body #genotext h1 {
    font-family: Belleza !important;
  }

  body.presentation-page .wrapper .page-small-header-image {
    background-image: url('/img/blurcrowd.jpg');
    /*
    position: absolute;
    top: auto;
    width: 100%;
    height: 75px;
    z-index: 33;
    */
    text-align: center;
  }

  /*
body.presentation-page #app .wrapper .demotext {
    top: 82px;
    margin-top: 78px;
   background: #f2f2f2a8 !important;
    color: #2c3c50b0;
    color: #4e4f50;
    width: 100%;
    height: 65px;
    padding-top: 13px;
    font-size: 1.2em;
    border-radius: 0px;
    box-shadow: none;
    cursor: default;
    pointer-events: none;
}
*/
  body.presentation-page #app .wrapper .demotext {
    top: 82px;
    margin-top: 100px;
    width: 478px;
    height: 49px;
    border-radius: 35px;
    cursor: default;
    pointer-events: none;
  }

  .demotext p {
    font-weight: 700;
  }

  video2 {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    overflow: hidden;
  }

  video {
    position: absolute;
    top: 20px;
    right: -5%;
    width: 105%;
    height: auto;
    max-height: 1200px;
    overflow: hidden;
  }

  body .swiper-slide.video .signUp {
    z-index: 1031;
    width: 100%;
    height: 95px;
    margin: auto;
    padding-top: 18px;
    background: #f2f2f2a8;
    margin-top: 58%;
  }

  .presentation-page #app .swiper-slide.video .signUp a.btn.btn-primary {
    width: 124px;
    height: 50px;
  }

  .presentation-page #app .swiper-slide.video .signUp a.btn.btn-primary p {
    line-height: 2.1em;
    font-size: 1.3em;
  }

  body.presentation-page .wrapper .intro .hello {
    font-size: 56px;
    width: 100%;
    color: white;
    position: absolute;
    top: 45%;
    font-weight: 700;
  }

  body .wrapper .page-header {
    opacity: 1;
    transition: opacity 1s;
  }

  body .wrapper .intro {
    pointer-events: none;
    opacity: 0;
    transition: opacity 1s;
  }

  body .wrapper .intro.fadein {
    pointer-events: none;
    opacity: 1;
  }

  body .wrapper .page-header.fadeout {
    pointer-events: none;
    opacity: 0;
  }

  /*
      body.presentation-page .page-header-image {
      background-image: url('/img/presentation-page/nuk-pro-back-sky.jpg');
      }
     body.presentation-page  .page-header-image.page-header-city {
     background-image: url('/img/crowd.png');
      }
*/
  .presentation-page #app .rellax-text-container,
  .index-page .rellax-text-container {
    top: 10%;
  }

  .presentation-page #app .page-header-city,
  .index-page .page-header-city {
    top: 10%;
  }

  .presentation-page #app .subtext .h3-description,
  .index-page .h3-description {
    display: inline-block;
    position: relative;
    margin-top: 25px;
    padding: 10px 12px;
    border-radius: 50px;
    opacity: 1;
    -webkit-transition: opacity 0.5s;
    transition: opacity 0.5s;
    width: auto;
    text-align: center;
    box-shadow: 0 5px 35px 0 rgba(0, 0, 0, .3);
    text-shadow: -5px 0px 20px #292f3d33, 5px 0px 20px #292f3d33, 0 -5px 20px #292f3d33, 0 5px 20px #292f3d33);
  }

  .presentation-page #app.scrolled .h3-description {
    opacity: 0;
  }

  #app .subtext {
    width: 100%;
    text-align: center;
  }

  #app .rellax-text-container {
    opacity: 1;
    transition: opacity 0.75s;
  }

  #app.scrolled .rellax-text-container {
    opacity: 0;
  }

  .signUp {
    position: relative;
    z-index: 10;
    text-align: center;
    width: 100%;
    margin-top: -20px;
    transition: opacity 0.75s;
  }

  .presentation-page #app.scrolled .signUp {
    opacity: 0;
  }

  .presentation-page #app .signUp a.btn.btn-primary {
    display: inline-block;
    height: 42px;
    color: white;
    border: 0px solid rgba(255, 255, 255, 1);
    padding: 9px 24px;
    text-transform: uppercase;
    top: 50%;
    border-radius: 50px;
  }

  .presentation-page #app .signUp a:active,
  .presentation-page #app .signUp a:hover {
    border: 2px solid rgb(255, 255, 255);
  }

  body.presentation-page .page-header,
  .index-page .page-header {
    background: #a6aaaf;
    z-index: 1;
  }

  body.presentation-page #app .subtext .h3-description,
  .index-page .h3-description {
    background-color: #292f3d33;
    font-family: Lato;
    font-size: 2em;
  }

  body.presentation-page .rellax-text-container .h1-seo,
  .index-page .rellax-text-container .h1-seo {
    background: linear-gradient(to bottom, #FFFFFF 35%, #a6aaaf 100%);
  }

  body.presentation-page .page-header-image {
    background-image: url('/img/nuk-pro-back-sky-dark.jpg');
  }

  body.presentation-page .page-header-image.page-header-city {
    background-image: url('/img/crowd-dark-small.png');
  }

  body.presentation-page .credits {
    background-color: #7c8086;
  }

  @media only screen and (max-width: 991px) {

    body .swiper-slide video {
      margin-top: 10%;
      zoom: 60%;
    }

    body.presentation-page #app .wrapper .demotext {
      width: 100%;
      margin-left: -5px;
      border-radius: 3px;
    }

    body.presentation-page #app .wrapper .demotext p {
      font-size: 1.05em;
    }

    body.presentation-page #app .rellax-text-container {
      top: 21%;
      left: -3%;
      font-size: 0.8em;
    }

    body.presentation-page #app .subtext .h3-description {
      margin-right: 20px;
      margin-top: 136px;
    }
  }

  #about.genoplot-aboutus-content {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  #frontpage .section {
    background: #323f4c;
    background: #01060d;
  }

  body #app .navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {
    color: #ffffff !important;
    transition: color 0.3s, background 0.3s, background-color 0.3s;
  }

  body.frontpage #app .bg-white {
    background-color: #323f4c !important;
    background-color: #01060d !important;
    color: white !important;
    box-shadow: 0px -6px 20px 0px rgba(228, 228, 228, 0.15);
    transition: color 0.3s, background 0.3s, background-color 0.3s;
  }

  body #app>.navbar {
    background-color: #000000 !important;
    color: white !important;
  }

  body #app .navbar.fixed-top.bg-white div.credits {
    color: white;
  }

  body #app.scrolled .dropdown-menu {
    background-color: #33373b !important;
    border: 1px solid #e8e8e84f;
    -webkit-box-shadow: 0px 0px 15px 0px rgb(62 77 95 / 42%);
    box-shadow: 0px 0px 15px 0px rgb(62 77 95 / 42%);
    color: white !important;
  }

  body #app.scrolled .dropdown-menu a.dropdown-item {
    color: white !important;
  }

  body #app #page #about {
    padding-top: 0;
    padding-bottom: 0;
    color: white;
  }

  body #genotext h1,
  body #genotext h2,
  body #genotext h3,
  body #genotext h4,
  body #genotext h5 {
    color: white !important;
    font-family: Belleza;
    font-weight: 700 !important;
  }

  body #genotext h4 {
    font-family: Belleza;
    opacity: 1;
  }

  body #app #page .info {
    padding-top: 40px;
  }

  body #app #page .description {
    color: white;
    font-family: Lato;
    opacity: 0.9;
    font-weight: 300 !important;
  }

  body #app #page .info .description {
    font-size: 1.4em;
    line-height: 1.4em;
    font-weight: 300;
  }

  body .info.info-hover .icon.icon-calc {
    box-shadow: none;
    width: 100%;
    display: block;
    height: 64px;
    background: #171717;
    color: white;
    text-decoration: none;
    padding-left: 20px;
  }

  body .info.info-hover .icon.icon-monte {
    background: #171717;
  }

  body .info.info-hover .icon.icon-pca {
    background: #171717;
  }

  body .info.info-hover .icon.icon-calc:before {
    content: '';
    background: url('/temp/img/calc.png');
    background-size: cover;
    position: absolute;
    width: 64px;
    height: 64px;
    margin-left: -32px;
  }

  body .info.info-hover .icon.icon-monte {
    box-shadow: none;
    width: 100%;
    display: block;
    height: 64px;
    background: black;
    color: white;
    text-decoration: none;
    padding-left: 20px;
  }

  body .info.info-hover .icon.icon-monte:before {
    content: '';
    background: url('/temp/img/monte.png');
    background-size: cover;
    position: absolute;
    width: 64px;
    height: 64px;
    margin-left: -32px;
  }

  body .info.info-hover .icon.icon-pca {
    box-shadow: none;
    width: 100%;
    display: block;
    height: 64px;
    background: black;
    color: white;
    text-decoration: none;
    padding-left: 20px;
  }

  body .info.info-hover .icon.icon-pca:before {
    content: '';
    background: url('/temp/img/pcaicon.png');
    background-size: cover;
    position: absolute;
    width: 64px;
    height: 64px;
    margin-left: -32px;
  }

  body .info.info-hover:hover .icon.icon-success.icon-circle {
    box-shadow: none;
  }

  body #genotext .features-3 {
    padding-bottom: 0;
  }

  body #genotext .separator-line.separator-primary {}

  body #genotext .genomics .separator-line.separator-primary {
    width: 300px;
    max-width: 80%;
    margin-top: 50px;
  }

  body .card-background:after {
    background-color: rgba(0, 0, 0, 0.45);
  }

  .presentation-page.frontpage #app .signUp.callout {
    opacity: 1;
  }

  .presentation-page.frontpage #app .signUp.callout a.btn.btn-primary {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .presentation-page.frontpage #app .signUp.callout a.btn.btn-primary p {
    margin: 0;
    line-height: unset;
    font-family: 'Belleza';
    font-weight: 700;
  }

  body .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (min-width: 576px) {
    body .container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    body .container {
      max-width: 720px;
    }
  }

  @media (min-width: 992px) {
    body.container {
      max-width: 960px;
    }
  }

  @media (min-width: 1200px) {
    body .container {
      max-width: 1140px;
    }
  }

  .features-1,
  .features-2,
  .features-3 {
    text-align: center;
  }

  @media (min-width: 768px) {
    .col-md-8 {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
  }

  .ml-auto,
  .mx-auto {
    margin-left: auto !important;
  }

  .mr-auto,
  .mx-auto {
    margin-right: auto !important;
  }

  #genotext,
  .section {
    background: #030303;
    color: white;
    text-align: center;
  }

  body [class*="col-"] {
    float: unset;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h01,
  .h02,
  .h03,
  .h04,
  .h05,
  .h06 {
    color: white;
  }

  .row {
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
    width: 100%;
  }

  .row,
  div.topcontainer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: normal;
  }

  .row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  @media (min-width: 768px) {
    .col-md-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }

  .home-content .row {
    width: 94%;
    max-width: 1200px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 1500px) {
    body .home-content .home-content__main {
      max-width: 1000px;
    }
  }

  .home-content__main {
    padding-right: 300px;
    position: relative;
  }

  .h4,
  h4 {
    font-size: 1.5em;
    line-height: 1.5em;
    margin-top: 30px;
    margin-bottom: 15px;
  }

  body #genotext .genomics .separator-line.separator-primary {
    width: 300px;
    max-width: 80%;
    margin-top: 50px;
  }

  .separator-line.separator-primary {
    background-color: #f96332;
  }

  .separator-line {
    height: 2px;
    width: 44px;
    background-color: #888;
    margin: 20px auto;
  }

  .projects-5 .card-background .card-body {
    padding-top: 140px;
    padding-bottom: 140px;
  }

  .card-background.card-background-product .card-body {
    max-width: 400px;
  }

  body.frontpage .card-background .card-body {
    position: relative;
    z-index: 2;
    min-height: 370px;
    max-width: 530px;
    margin: 0 auto;
    padding: 0;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }

  .projects-5 .card-background {
    margin-bottom: 0;
  }

  .card-raised {
    -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 30%);
    box-shadow: 0 20px 50px 0 rgb(0 0 0 / 30%);
  }

  .card-background {
    background-position: 50%;
    background-size: cover;
    text-align: center;
  }

  .card {
    border: 0;
    border-radius: .1875rem;
    display: inline-block;
    position: relative;
    width: 100%;
    margin-bottom: 30px;
    -webkit-box-shadow: 0 5px 25px 0 rgb(0 0 0 / 20%);
    box-shadow: 0 5px 25px 0 rgb(0 0 0 / 20%);
  }

  .section-space {
    height: 62px;
    display: block;
  }

  @media (min-width: 768px) {
    .col-md-5 {
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
  }

  .col,
  .col-1,
  .col-10,
  .col-11,
  .col-12,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-auto {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .text-center {
    text-align: center !important;
  }

  .ml-auto,
  .mx-auto {
    margin-left: auto !important;
  }

  .mr-auto,
  .mx-auto {
    margin-right: auto !important;
  }

  @media (min-width: 768px) {
    .col-md-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }

  #app span.nav-link.btn.btn-primary {
    border-radius: 24px;
    padding: 9px 24px;
    font-family: 'Belleza';
  }

  #app span.nav-link.btn.btn-primary p {
    margin: 0;
    text-transform: uppercase;
  }

  body #app .btn {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }

  #app .btn-icon,
  #app .btn-primary,
  #app .btn-round {
    -webkit-box-shadow: 0 5px 35px 0 rgb(0 0 0 / 30%);
    box-shadow: 0 5px 35px 0 rgb(0 0 0 / 30%);
    border: none;
  }

  #app .btn-primary {
    background-color: #e46f49 !important;
    background-color: #e65929 !important;
  }

  .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  body .card-background:after {
    background-color: rgba(0, 0, 0, .05);
  }

  .card-background:after {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: block;
    left: 0;
    top: 0;
    content: "";
    border-radius: .25rem;
  }

  .s-home {
    min-height: 400px;
  }

  body #app .home-content__buttons .btn {
    display: block !important;
  }

  .s-header.sticky.scrolling {
    border-bottom: 1px solid #ffffff30;
  }

  body .icon {
    background: #030303 !important;
  }

  .header-nav li a.login {
    color: #e65929;
  }

  body #homeimage.isdesktop {
    opacity: 0;
    transition: opacity 0.5s;
  }

  body #homeimage.ismobile {
    opacity: 1;
  }

  body.isMobile #homeimage.isdesktop {
    opacity: 1;
    display: block;
  }

  body.isMobile #homeimage.ismobile {
    opacity: 1;
    display: block;
  }

  body.isDesktop #homeimage.isdesktop {
    opacity: 1;
  }

  .header-nav .nuxt-link-prefetched {}

  #genotext .card .card-title {
    position: absolute;
    top: 30%;
    text-align: center;
    width: 100%;
    padding: 10px 0 15px;
    background: #030303;
    left: 0;
    font-size: 2.5em;
  }

  #genotext .card.card-background .card-body {
    max-width: 400px;
    max-height: 400px;
    padding-top: 0;
    padding-bottom: 0;
  }

  #genotext .card.card-background .card-body img {
    filter: brightness(0.6);
  }

  .v--modal-overlay .v--modal-box {
    border-radius: 9px;
  }

  .card-background .card-body {
    padding-top: 140px;
    padding-bottom: 140px;
  }

  .card-background.card-background-product .card-body {
    max-width: 400px;
  }

  .card-background .card-body {
    position: relative;
    z-index: 2;
    min-height: 370px;
    max-width: 530px;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }

  #genotext .info ::v-deep p.description {
    color: white;
    padding: 0 15px;
    font-size: 1.4em;
    line-height: 1.5em;
    margin-top: 30px;
    margin-bottom: 15px;
    opacity: 0.9;
  }

  .home-content .smoothscroll.btn.btn--stroke {
    font-size: 1em !important;
    font-weight: 700;
    line-height: 3.8em;
    border-width: 4px;
  }

  .home-content h3 {
    font-size: 1.3em;
    font-weight: 700;
  }

  .home-content .home-content__scroll {
    font-size: 0.5em;
    bottom: -8.2rem;
  }

  .home-content .home-content__scroll a {
    font-size: 2em;
    font-weight: 700;
    letter-spacing: 0.2em;
  }

  .home-content h3#subh {
    color: white;
    font-size: 1em;
    font-style: italic;
    text-transform: lowercase;
    display: block;
    padding-left: 85px;
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: -68px;
  }

  .home-content h3#subh:last-child {
    margin-bottom: -30px;
  }

  body.isMobile .home-content h3#subh {
    padding-left: 50px;
  }

  .home-content h3#subh:before {
    background-color: transparent;
  }

  section#GenomicAnalysis {
    background: inherit;
  }

  @media only screen and (max-width: 600px) {
    #comments h3 {
      text-align: center;
    }

    .commentlist>.comment {
      padding-left: 0;
    }

    .commentlist .comment__avatar {
      display: none;
    }

    .home-content__buttons {
      position: static;
      text-align: center;
    }

    body #app .home-content__buttons .btn {
      display: inline-block !important;
    }

    .quote-wrapper blockquote footer {
      font-size: 17px;
      bottom: -10px;
      margin-top: 40px;
      margin-left: -10px;
      font-size: 1.2em;
      margin-top: 38px;
    }

    .quote-wrapper blockquote {
      margin-left: 0px;
    }

    .quote-wrapper::before {
      margin-left: -20px;
    }

    .home-content__scroll {
      margin-left: 1.5rem;
    }

    .home-content__buttons {
      position: relative;
      text-align: center;
      display: block;
      width: 100%;
      right: unset;
      margin-top: 50px;
    }

    body #app .home-content__buttons .btn {
      display: inline-flex !important;
      max-width: 60%;
    }

    body .home-content .home-content__main {
      padding-right: unset;
    }

    .home-content.global #subheaders {
      margin-left: 1.5rem;
      margin-bottom: 50px;
    }

    .home-content__main #subheaders h1 {
      font-size: 2rem;
      letter-spacing: 1px;
      word-spacing: 1px;
    }
  }

  @media only screen and (max-width: 400px) {
    body #mainBody #home.home-content.global {
      top: 50px;
    }

    body.isMobile .home-content.global h1 {
      font-size: 3rem;
      letter-spacing: 1px;
      word-spacing: 1px;
    }
  }

  @media only screen and (max-width: 600px) {
    .home-content__scroll {
      margin-left: 1.5rem;
      display: none;
    }

    .home-content__buttons {
      position: relative;
      text-align: center;
      display: block;
      width: 100%;
      right: unset;
      margin-top: 50px;
    }

    body #app .home-content__buttons .btn {
      display: inline-flex !important;
      max-width: 80%;
    }

    body .home-content .home-content__main,
    body.isMobile .home-content .home-content__main {
      top: 0px;
      padding-right: unset;
    }

    .home-content #subheaders {
      margin-left: 1.5rem;
      margin-bottom: 50px;
    }

    .home-content h1 {
      font-size: 2.2rem;
    }

    .row .home-content__teasers {
      margin-top: -40px;
    }

    .home-content {
      padding-bottom: 40px;
    }

    .home-content h1 {
      font-size: 4.2rem;
    }

    .home-content__main {
      max-width: 380px;
      padding: 0;
    }

    .home-content__scroll {
      bottom: -9rem;
    }

    .home-social {
      padding-bottom: 10.8rem;
    }

    .home-social::after {
      height: 10.2rem;
    }
  }

  @media only screen and (max-width: 500px) {
    .s-home {
      min-height: 654px;
    }

    .home-content h3 {
      font-size: 1.3rem;
    }

    .home-content h1 {
      font-size: 3.5rem;
    }

    .home-content__main {
      max-width: none;
      width: 85%;
      margin-top: 150px;
    }
  }

  @media only screen and (max-width: 400px) {
    .home-content__scroll {
      margin-left: 1.5rem;
      display: none;
    }

    .home-content__buttons {
      position: relative;
      text-align: center;
      display: block;
      width: 100%;
      right: unset;
      margin-top: 50px;
    }

    body #app .home-content__buttons .btn {
      display: inline-flex !important
    }

    body .home-content .home-content__main,
    body.isMobile .home-content .home-content__main {
      top: 40px;
      padding-right: unset;
    }

    .home-content #subheaders {
      margin-left: 1.5rem;
      margin-bottom: 50px;
    }

    .home-content h1 {
      font-size: 2.2rem;
    }

    .home-content {
      vertical-align: middle;
    }

    .home-content h1 {
      font-size: 2.5rem;
    }

    .home-content__main {
      width: auto;
      margin-left: 25px;
      margin-right: 25px;
    }

    .home-content__buttons .btn {
      width: 100%;
    }

    .home-social {
      display: none;
    }
  }

  body.isMobile .home-content span.item-loop {
    display: none;
  }

  .home-content span.item-loop {
    background: white;
    opacity: 0.05;
    transition: opacity 0.3s;
  }

  .home-content span.item-loop.looped {
    background: orange;
    opacity: 0.05;
  }

  .home-content span.item-loop:hover {
    opacity: 1;
  }

section#Reviews  {
margin-bottom: -92px;
padding-bottom: 0;
padding-top: 0;
}
  section#Reviews * {
    color: white;
  }

  section#Reviews .quote-wrapper {
    position: relative;
    margin: 10vh auto 0;
    /*OPTIONAL MARGIN*/
    margin-bottom: -40px;
    color: white;
    width: 300px;
    height: 300px;
  }

    section#Reviews .quote-wrapper {
      width: 370px;
      height: 370px;
    }

    section#Reviews .text p {
      font-size: 26px;
    }

  section#Reviews .text {
    width: 100%;
    height: 100%;
    position: relative;
    margin: 0;
    margin-left: 22px;
    margin-top: 20px;
    top: -49px;
    color: white;
  }

  section#Reviews .text:before {
    content: "";
    width: 50%;
    height: 100%;
    shape-margin: 7%;
    float: left;
    shape-outside: polygon(0 0, 98% 0, 50% 6%, 23.4% 17.3%, 6% 32.6%, 0 50%, 6% 65.6%, 23.4% 82.7%, 50% 94%, 98% 100%, 0 100%);
  }
section#Reviews .quote-wrapper blockquote footer {
    width: 100%;
    position: absolute;
    font-size: 17px;
    bottom: 18px;
    color: #fff;
    text-align: center;
    font-size: 1.5em;
    margin-left: 32px;
    margin-top: 38px;
    color: orange;
    text-shadow: .5px .5px 1px rgba(0, 0, 0, .3);
}
section#Reviews .quote-wrapper:before {
    content: "\201C";
    font-size: 270px;
    height: 82px;
    line-height: .78;
    line-height: 1;
    position: absolute;
    top: -48px;
    left: 0;
    z-index: 1;
    font-family: sans-serif, serif;
    color: #b27608;
    opacity: .9;
}

  section#Reviews .text p {
    line-height: 1.25;
    padding: 70px 0 0;
    text-align: center;
    font-style: italic;
    font-family: Lato, sans-serif !important;
    font-weight: 300;
    font-size: 26px;
    text-shadow: .5px .5px 1px rgba(0, 0, 0, .3);
  }
body.isMobile section#Reviews .quote-wrapper blockquote footer {
position: relative;
top: -136px;
margin-left: 0;
}
body.isMobile section#Reviews .quote-wrapper {
height: 300px;
width: 300px;
margin-left: -35px;
}
body.isMobile section#Reviews .quote-wrapper:before {
left: 20px;
}
body.isMobile #GenomicAnalysis {
top: -172px;
}
</style>
